"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setShowOnlySelfTasks = setShowOnlySelfTasks;
exports.stepOnboarderForwards = stepOnboarderForwards;
exports.stepOnboarderBackwards = stepOnboarderBackwards;
exports.setInformationDialog = setInformationDialog;
exports.setItemSelectDialog = setItemSelectDialog;
exports.setQuickItemSelectDialog = setQuickItemSelectDialog;
exports.cancelTaskMove = cancelTaskMove;
exports.setIsInRegisterMode = setIsInRegisterMode;
exports.setOpenProjectSelectorId = setOpenProjectSelectorId;
exports.setUpdatingUserIds = setUpdatingUserIds;
exports.setOpenTaskListWidgetHeaderId = setOpenTaskListWidgetHeaderId;
exports.setTextInputDialog = setTextInputDialog;
exports.setOpenTaskOptionsId = setOpenTaskOptionsId;
exports.receiveMembers = receiveMembers;
exports.receiveInvites = receiveInvites;
exports.receiveRemoteProjects = receiveRemoteProjects;
exports.setDisplayName = setDisplayName;
exports.setShareMenuMessage = setShareMenuMessage;
exports.setShareMenuSubMessage = setShareMenuSubMessage;
exports.setIsShareMenuWaiting = setIsShareMenuWaiting;
exports.openShareMenu = openShareMenu;
exports.closeShareMenu = closeShareMenu;
exports.setIsAppDrawerOpen = setIsAppDrawerOpen;
exports.clearData = clearData;
exports.openTaskInfo = openTaskInfo;
exports.dismissSnackbar = dismissSnackbar;
exports.setGeneralSnackbar = setGeneralSnackbar;
exports.setIsLoggedInFlag = setIsLoggedInFlag;
exports.setUserEmail = setUserEmail;
exports.setIsLoggingInFlag = setIsLoggingInFlag;
exports.setIsAppDrawerCollapsed = setIsAppDrawerCollapsed;
exports.setLastUndoAction = setLastUndoAction;
exports.setAuthStatusMessage = setAuthStatusMessage;
exports.setMessageBox = setMessageBox;
exports.setOpenChecklistSettingsId = setOpenChecklistSettingsId;
exports.receiveCSSConfig = receiveCSSConfig;
exports.setIgnoreFullscreenTriggerFlag = setIgnoreFullscreenTriggerFlag;
exports.receiveAccountConfig = receiveAccountConfig;
exports.setIsAppSettingsOpen = setIsAppSettingsOpen;
exports.setIsDexieConfigLoadComplete = setIsDexieConfigLoadComplete;
exports.setIsDatabaseRestoringFlag = setIsDatabaseRestoringFlag;
exports.setIsStartingUpFlag = setIsStartingUpFlag;
exports.setIsRestoreDatabaseCompleteDialogOpen = setIsRestoreDatabaseCompleteDialogOpen;
exports.setDatabasePurgingFlag = setDatabasePurgingFlag;
exports.setDatabaseInfo = setDatabaseInfo;
exports.setAppSettingsMenuPage = setAppSettingsMenuPage;
exports.setIsShuttingDownFlag = setIsShuttingDownFlag;
exports.setFocusedTaskListId = setFocusedTaskListId;
exports.openChecklistSettings = openChecklistSettings;
exports.setIsOnboarding = setIsOnboarding;
exports.closeChecklistSettings = closeChecklistSettings;
exports.selectTask = selectTask;
exports.openTask = openTask;
exports.closeTask = closeTask;
exports.startTaskMoveInDatabase = startTaskMoveInDatabase;
exports.startProjectsFetch = startProjectsFetch;
exports.receiveLocalProjects = receiveLocalProjects;
exports.startTasksFetch = startTasksFetch;
exports.lockApp = lockApp;
exports.unlockApp = unlockApp;
exports.setLastBackupDate = setLastBackupDate;
exports.setOpenTaskListSettingsMenuId = setOpenTaskListSettingsMenuId;
exports.setUpdatingInviteIds = setUpdatingInviteIds;
exports.startTasklistAdd = startTasklistAdd;
exports.startTaskAdd = startTaskAdd;
exports.startTaskListsFetch = startTaskListsFetch;
exports.receiveLocalTaskLists = receiveLocalTaskLists;
exports.receiveRemoteTaskLists = receiveRemoteTaskLists;
exports.startProjectLayoutsFetch = startProjectLayoutsFetch;
exports.receiveLocalProjectLayouts = receiveLocalProjectLayouts;
exports.receiveRemoteProjectLayouts = receiveRemoteProjectLayouts;
exports.setProjectsHavePendingWrites = setProjectsHavePendingWrites;
exports.setProjectLayoutsHavePendingWrites = setProjectLayoutsHavePendingWrites;
exports.setTaskListsHavePendingWrites = setTaskListsHavePendingWrites;
exports.selectMuiTheme = selectMuiTheme;
exports.setTasksHavePendingWrites = setTasksHavePendingWrites;
exports.setIsInducting = setIsInducting;
exports.openJumpMenu = openJumpMenu;
exports.closeJumpMenu = closeJumpMenu;
exports.receiveGeneralConfig = receiveGeneralConfig;
exports.receiveRemoteProjectIds = receiveRemoteProjectIds;
exports.setUndoSnackbar = setUndoSnackbar;
exports.setShowCompletedTasks = setShowCompletedTasks;
exports.receiveIncompletedLocalTasks = receiveIncompletedLocalTasks;
exports.setConfirmationDialog = setConfirmationDialog;
exports.receiveCompletedLocalTasks = receiveCompletedLocalTasks;
exports.receiveIncompletedRemoteTasks = receiveIncompletedRemoteTasks;
exports.receiveCompletedRemoteTasks = receiveCompletedRemoteTasks;
exports.selectProject = selectProject;
exports.setIsProjectMenuOpen = setIsProjectMenuOpen;
exports.calculateProjectSelectorIndicators = calculateProjectSelectorIndicators;
exports.setIsUpdateSnackbarOpen = setIsUpdateSnackbarOpen;
exports.startTaskCommentsGet = startTaskCommentsGet;
exports.receiveTaskComments = receiveTaskComments;
exports.setPendingTaskCommentIds = setPendingTaskCommentIds;
exports.setIsTaskCommentsPaginating = setIsTaskCommentsPaginating;
exports.setIsAllTaskCommentsFetched = setIsAllTaskCommentsFetched;
exports.setSelectedProjectLayoutType = setSelectedProjectLayoutType;
exports.receiveLocalMuiThemes = receiveLocalMuiThemes;
exports.bumpVersionNumberToCurrentAsync = bumpVersionNumberToCurrentAsync;
exports.persistMuiThemeSelection = persistMuiThemeSelection;
exports.updateMuiThemeAsync = updateMuiThemeAsync;
exports.renameMuiThemeAsync = renameMuiThemeAsync;
exports.removeMuiThemeAsync = removeMuiThemeAsync;
exports.createNewMuiThemeAsync = createNewMuiThemeAsync;
exports.getLocalMuiThemes = getLocalMuiThemes;
exports.startTaskMoveAsync = startTaskMoveAsync;
exports.moveTaskListToProjectAsync = moveTaskListToProjectAsync;
exports.updateProjectLayoutTypeAsync = updateProjectLayoutTypeAsync;
exports.openTaskInspector = openTaskInspector;
exports.closeTaskInspectorAsync = closeTaskInspectorAsync;
exports.getTaskCommentsAsync = getTaskCommentsAsync;
exports.paginateTaskCommentsAsync = paginateTaskCommentsAsync;
exports.deleteTaskCommentAsync = deleteTaskCommentAsync;
exports.postNewCommentAsync = postNewCommentAsync;
exports.manuallyRenewChecklistAsync = manuallyRenewChecklistAsync;
exports.renewChecklistAsync = renewChecklistAsync;
exports.setShowCompletedTasksAsync = setShowCompletedTasksAsync;
exports.updateTaskNoteAsync = updateTaskNoteAsync;
exports.updateTaskAssignedToAsync = updateTaskAssignedToAsync;
exports.sendPasswordResetEmailAsync = sendPasswordResetEmailAsync;
exports.registerNewUserAsync = registerNewUserAsync;
exports.acceptProjectInviteAsync = acceptProjectInviteAsync;
exports.denyProjectInviteAsync = denyProjectInviteAsync;
exports.getRemoteProjectIdsAsync = getRemoteProjectIdsAsync;
exports.subscribeToRemoteProjectAsync = subscribeToRemoteProjectAsync;
exports.unsubscribeFromRemoteProjectAsync = unsubscribeFromRemoteProjectAsync;
exports.migrateProjectBackToLocalAsync = migrateProjectBackToLocalAsync;
exports.inviteUserToProjectAsync = inviteUserToProjectAsync;
exports.undoLastActionAsync = undoLastActionAsync;
exports.updateMemberRoleAsync = updateMemberRoleAsync;
exports.leaveRemoteProjectAsync = leaveRemoteProjectAsync;
exports.kickUserFromProjectAsync = kickUserFromProjectAsync;
exports.attachAuthListenerAsync = attachAuthListenerAsync;
exports.subscribeToDatabaseAsync = subscribeToDatabaseAsync;
exports.getInvitesAsync = getInvitesAsync;
exports.unsubscribeFromDatabaseAsync = unsubscribeFromDatabaseAsync;
exports.unsubscribeRemoteIds = unsubscribeRemoteIds;
exports.logOutUserAsync = logOutUserAsync;
exports.logInUserAsync = logInUserAsync;
exports.setFavouriteProjectIdAsync = setFavouriteProjectIdAsync;
exports.getGeneralConfigAsync = getGeneralConfigAsync;
exports.getCSSConfigAsync = getCSSConfigAsync;
exports.setAllColorsToDefaultAsync = setAllColorsToDefaultAsync;
exports.setCSSConfigAsync = setCSSConfigAsync;
exports.setGeneralConfigAsync = setGeneralConfigAsync;
exports.purgeCompleteTasksAsync = purgeCompleteTasksAsync;
exports.getDatabaseInfoAsync = getDatabaseInfoAsync;
exports.updateTaskPriorityAsync = updateTaskPriorityAsync;
exports.updateTaskDueDateAsync = updateTaskDueDateAsync;
exports.updateChecklistSettingsAsync = updateChecklistSettingsAsync;
exports.updateTaskListSettingsAsync = updateTaskListSettingsAsync;
exports.removeTaskListAsync = removeTaskListAsync;
exports.updateProjectNameAsync = updateProjectNameAsync;
exports.removeProjectAsync = removeProjectAsync;
exports.removeLocalProjectAsync = removeLocalProjectAsync;
exports.removeRemoteProjectAsync = removeRemoteProjectAsync;
exports.addNewProjectAsync = addNewProjectAsync;
exports.updateTaskCompleteAsync = updateTaskCompleteAsync;
exports.updateProjectLayoutAsync = updateProjectLayoutAsync;
exports.updateTaskNameAsync = updateTaskNameAsync;
exports.updateTaskNameWithDialogAsync = updateTaskNameWithDialogAsync;
exports.removeSelectedTaskAsync = removeSelectedTaskAsync;
exports.removeTaskAsync = removeTaskAsync;
exports.updateTaskListNameAsync = updateTaskListNameAsync;
exports.moveTaskViaDialogAsync = moveTaskViaDialogAsync;
exports.moveTaskAsync = moveTaskAsync;
exports.getLastUndoActionAsync = getLastUndoActionAsync;
exports.addNewTaskAsync = addNewTaskAsync;
exports.addNewTaskListAsync = addNewTaskListAsync;
exports.getAccountConfigAsync = getAccountConfigAsync;
exports.getProjectsAsync = getProjectsAsync;
exports.getIncompletedLocalTasksAsync = getIncompletedLocalTasksAsync;
exports.getCompletedLocalTasksAsync = getCompletedLocalTasksAsync;
exports.getTaskListsAsync = getTaskListsAsync;
exports.getLocalProjectLayoutsAsync = getLocalProjectLayoutsAsync;
exports.unsubscribeAccountConfigAsync = unsubscribeAccountConfigAsync;
exports.unsubscribeProjectsAsync = unsubscribeProjectsAsync;
exports.unsubscribeTaskListsAsync = unsubscribeTaskListsAsync;
exports.unsubscribeTasksAsync = unsubscribeTasksAsync;
exports.unsubscribeInvitesAsync = unsubscribeInvitesAsync;
exports.unsubscribeProjectLayoutsAsync = unsubscribeProjectLayoutsAsync;

var ActionTypes = _interopRequireWildcard(require("../action-types/index"));

var _firestoreBatchPaginator = _interopRequireDefault(require("../../firestore-batch-paginator"));

var _paths = require("../../pounder-firebase/paths");

var _pounderFirebase = require("../../pounder-firebase");

var _pounderStores = require("../../pounder-stores");

var JobTypes = _interopRequireWildcard(require("../../pounder-firebase/jobTypes"));

var _moment = _interopRequireDefault(require("moment"));

var _index2 = require("../index");

var _minimist = _interopRequireDefault(require("minimist"));

var _stringArgv = _interopRequireDefault(require("string-argv"));

var _fuse = _interopRequireDefault(require("fuse.js"));

var _pounderUtilities = require("../../pounder-utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var loremIpsum = require('lorem-ipsum');

var legalArgsRegEx = / -dd | -hp /i;
var DATE_FORMAT = 'dddd MMMM Do YYYY, h:mm a';
var newUser = null; // Database Unsubscribers.

var localProjectsUnsubscribe = null;
var localProjectLayoutsUnsubscribe = null;
var remoteProjectIdsUnsubscribe = null;
var localTaskListsUnsubscribe = null;
var accountConfigUnsubscribe = null;
var invitesUnsubscribe = null;
var onlyCompletedLocalTasksUnsubscribe = null;
var onlyIncompletedLocalTasksUnsubscribe = null;
var remoteProjectsUnsubscribes = {}; // Standard Action Creators.

function setShowOnlySelfTasks(newValue) {
  return {
    type: ActionTypes.SET_SHOW_ONLY_SELF_TASKS,
    value: newValue
  };
}

function stepOnboarderForwards() {
  return {
    type: ActionTypes.STEP_ONBOARDER_FORWARD
  };
}

function stepOnboarderBackwards() {
  return {
    type: ActionTypes.STEP_ONBOARDER_BACKWARDS
  };
}

function setInformationDialog(isOpen, text, title, onOkay) {
  return {
    type: ActionTypes.SET_INFORMATION_DIALOG,
    value: {
      isOpen: isOpen,
      text: text,
      title: title,
      onOkay: onOkay
    }
  };
}

function setItemSelectDialog(isOpen, title, text, items, affirmativeButtonText, negativeButtonText, onAffirmative, onNegative) {
  return {
    type: ActionTypes.SET_ITEM_SELECT_DIALOG,
    value: {
      isOpen: isOpen,
      title: title,
      text: text,
      items: items,
      affirmativeButtonText: affirmativeButtonText,
      negativeButtonText: negativeButtonText,
      onAffirmative: onAffirmative,
      onNegative: onNegative
    }
  };
}

function setQuickItemSelectDialog(isOpen, title, text, items, negativeButtonText, onSelect, onNegative) {
  return {
    type: ActionTypes.SET_QUICK_ITEM_SELECT_DIALOG,
    value: {
      isOpen: isOpen,
      title: title,
      text: text,
      items: items,
      negativeButtonText: negativeButtonText,
      onSelect: onSelect,
      onNegative: onNegative
    }
  };
}

function cancelTaskMove() {
  return {
    type: ActionTypes.CANCEL_TASK_MOVE
  };
}

function setIsInRegisterMode(value) {
  return {
    type: ActionTypes.SET_IS_IN_REGISTER_MODE,
    value: value
  };
}

function setOpenProjectSelectorId(projectId) {
  return {
    type: ActionTypes.SET_OPEN_PROJECT_SELECTOR_ID,
    value: projectId
  };
}

function setUpdatingUserIds(userIds) {
  return {
    type: ActionTypes.SET_UPDATING_USER_IDS,
    value: userIds
  };
}

function setOpenTaskListWidgetHeaderId(taskListId) {
  return {
    type: ActionTypes.SET_OPEN_TASK_LIST_WIDGET_HEADER_ID,
    value: taskListId
  };
}

function setTextInputDialog(isOpen, label, text, title, onCancel, onOkay) {
  return {
    type: ActionTypes.SET_TEXT_INPUT_DIALOG,
    value: {
      isOpen: isOpen,
      label: label,
      text: text,
      title: title,
      onCancel: onCancel,
      onOkay: onOkay
    }
  };
}

function setOpenTaskOptionsId(taskId) {
  return {
    type: ActionTypes.SET_OPEN_TASK_OPTIONS_ID,
    value: taskId
  };
}

function receiveMembers(members) {
  return {
    type: ActionTypes.RECEIVE_MEMBERS,
    members: members
  };
}

function receiveInvites(invites) {
  return {
    type: ActionTypes.RECEIVE_INVITES,
    invites: invites
  };
}

function receiveRemoteProjects(projects) {
  return {
    type: ActionTypes.RECEIVE_REMOTE_PROJECTS,
    projects: projects
  };
}

function setDisplayName(displayName) {
  return {
    type: ActionTypes.SET_DISPLAY_NAME,
    value: displayName
  };
}

function setShareMenuMessage(message) {
  return {
    type: ActionTypes.SET_SHARE_MENU_MESSAGE,
    value: message
  };
}

function setShareMenuSubMessage(message) {
  return {
    type: ActionTypes.SET_SHARE_MENU_SUB_MESSAGE,
    value: message
  };
}

function setIsShareMenuWaiting(value) {
  return {
    type: ActionTypes.SET_IS_SHARE_MENU_WAITING,
    value: value
  };
}

function openShareMenu(projectId) {
  return {
    type: ActionTypes.OPEN_SHARE_MENU,
    value: projectId
  };
}

function closeShareMenu() {
  return {
    type: ActionTypes.CLOSE_SHARE_MENU
  };
}

function setIsAppDrawerOpen(isOpen) {
  return {
    type: ActionTypes.SET_IS_APP_DRAWER_OPEN,
    value: isOpen
  };
}

function clearData() {
  return {
    type: ActionTypes.CLEAR_DATA
  };
}

function openTaskInfo(taskId) {
  return {
    type: ActionTypes.OPEN_TASK_INFO,
    value: taskId
  };
}

function dismissSnackbar() {
  return {
    type: ActionTypes.DISMISS_SNACKBAR
  };
}

function setGeneralSnackbar(isOpen, type, text, selfDismissTime) {
  var actionOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    actionButtonText: 'Okay',
    onAction: function onAction() {}
  };
  return {
    type: ActionTypes.SET_GENERAL_SNACKBAR,
    value: {
      isOpen: isOpen,
      type: type,
      text: text,
      selfDismissTime: selfDismissTime,
      actionOptions: actionOptions
    }
  };
}

function setIsLoggedInFlag(isLoggedIn) {
  return {
    type: ActionTypes.SET_IS_LOGGED_IN_FLAG,
    value: isLoggedIn
  };
}

function setUserEmail(email) {
  return {
    type: ActionTypes.SET_USER_EMAIL,
    value: email
  };
}

function setIsLoggingInFlag(isLoggingIn) {
  return {
    type: ActionTypes.SET_IS_LOGGING_IN_FLAG,
    value: isLoggingIn
  };
}

function setIsAppDrawerCollapsed(value) {
  return {
    type: ActionTypes.SET_IS_APP_DRAWER_COLLAPSED,
    value: value
  };
}

function setLastUndoAction(value) {
  return {
    type: ActionTypes.SET_LAST_UNDO_ACTION,
    value: value
  };
}

function setAuthStatusMessage(message) {
  return {
    type: ActionTypes.SET_AUTH_STATUS_MESSAGE,
    value: message
  };
}

function setMessageBox(isOpen, dialogTitle, message, type, dataStore, closeCallback) {
  return {
    type: ActionTypes.SET_MESSAGE_BOX,
    value: {
      isOpen: isOpen,
      dialogTitle: dialogTitle,
      message: message,
      type: type,
      closeCallback: closeCallback
    }
  };
}

function setOpenChecklistSettingsId(id) {
  return {
    type: ActionTypes.SET_OPEN_CHECKLIST_SETTINGS_ID,
    value: id
  };
}

function receiveCSSConfig(config) {
  return {
    type: ActionTypes.RECEIVE_CSS_CONFIG,
    value: config
  };
}

function setIgnoreFullscreenTriggerFlag(value) {
  return {
    type: ActionTypes.SET_IGNORE_FULLSCREEN_TRIGGER_FLAG,
    value: value
  };
}

function receiveAccountConfig(accountConfig) {
  return {
    type: ActionTypes.RECEIVE_ACCOUNT_CONFIG,
    value: accountConfig
  };
}

function setIsAppSettingsOpen(isOpen) {
  return {
    type: ActionTypes.SET_IS_APP_SETTINGS_OPEN,
    value: isOpen
  };
}

function setIsDexieConfigLoadComplete(isComplete) {
  return {
    type: ActionTypes.SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG,
    value: isComplete
  };
}

function setIsDatabaseRestoringFlag(isRestoring) {
  return {
    type: ActionTypes.SET_IS_DATABASE_RESTORING_FLAG,
    value: isRestoring
  };
}

function setIsStartingUpFlag(isStartingUp) {
  return {
    type: ActionTypes.SET_IS_STARTING_UP_FLAG,
    value: isStartingUp
  };
}

function setIsRestoreDatabaseCompleteDialogOpen(isOpen) {
  return {
    type: ActionTypes.SET_IS_RESTORE_DATABASE_COMPLETE_DIALOG_OPEN,
    value: isOpen
  };
}

function setDatabasePurgingFlag(isPurging) {
  return {
    type: ActionTypes.SET_DATABASE_PURGING_FLAG,
    value: isPurging
  };
}

function setDatabaseInfo(info) {
  return {
    type: ActionTypes.SET_DATABASE_INFO,
    value: info
  };
}

function setAppSettingsMenuPage(pageName) {
  return {
    type: ActionTypes.SET_APP_SETTINGS_MENU_PAGE,
    value: pageName
  };
}

function setIsShuttingDownFlag(isShuttingDown) {
  return {
    type: ActionTypes.SET_IS_SHUTTING_DOWN_FLAG,
    value: isShuttingDown
  };
}

function setFocusedTaskListId(id) {
  return {
    type: ActionTypes.SET_FOCUSED_TASKLIST_ID,
    id: id
  };
}

function openChecklistSettings(taskListId, existingChecklistSettings) {
  return {
    type: ActionTypes.OPEN_CHECKLIST_SETTINGS,
    taskListId: taskListId,
    existingChecklistSettings: existingChecklistSettings
  };
}

function setIsOnboarding(value) {
  return {
    type: ActionTypes.SET_IS_ONBOARDING,
    value: value
  };
}

function closeChecklistSettings() {
  return {
    type: ActionTypes.CLOSE_CHECKLIST_SETTINGS
  };
}

function selectTask(taskListWidgetId, taskId, openMetadata) {
  return {
    type: ActionTypes.SELECT_TASK,
    taskListWidgetId: taskListWidgetId,
    taskId: taskId,
    openMetadata: openMetadata
  };
}

function openTask(taskListWidgetId, taskId) {
  return {
    type: ActionTypes.OPEN_TASK,
    taskListWidgetId: taskListWidgetId,
    taskId: taskId
  };
}

function closeTask(taskListWidgetId, taskId) {
  return {
    type: ActionTypes.CLOSE_TASK,
    taskListWidgetId: taskListWidgetId,
    taskId: taskId
  };
}

function startTaskMoveInDatabase() {
  return {
    type: ActionTypes.START_TASK_MOVE_IN_DATABASE
  };
}

function startProjectsFetch() {
  return {
    type: ActionTypes.START_PROJECTS_FETCH
  };
}

function receiveLocalProjects(projects) {
  return {
    type: ActionTypes.RECEIVE_LOCAL_PROJECTS,
    projects: projects
  };
}

function startTasksFetch() {
  return {
    type: ActionTypes.START_TASKS_FETCH
  };
}

function lockApp() {
  return {
    type: ActionTypes.LOCK_APP
  };
}

function unlockApp() {
  return {
    type: ActionTypes.UNLOCK_APP
  };
}

function setLastBackupDate(date) {
  return {
    type: ActionTypes.SET_LAST_BACKUP_DATE,
    value: date
  };
}

function setOpenTaskListSettingsMenuId(id) {
  return {
    type: ActionTypes.SET_OPEN_TASKLIST_SETTINGS_MENU_ID,
    id: id
  };
}

function setUpdatingInviteIds(updatingInviteIds) {
  return {
    type: ActionTypes.SET_UPDATING_INVITE_IDS,
    value: updatingInviteIds
  };
}

function startTasklistAdd() {
  return {
    type: ActionTypes.START_TASKLIST_ADD
  };
}

function startTaskAdd() {
  return {
    type: ActionTypes.START_TASK_ADD
  };
}

function startTaskListsFetch() {
  return {
    type: ActionTypes.START_TASKLISTS_FETCH
  };
}

function receiveLocalTaskLists(taskLists) {
  return {
    type: ActionTypes.RECEIVE_LOCAL_TASKLISTS,
    taskLists: taskLists
  };
}

function receiveRemoteTaskLists(taskLists) {
  return {
    type: ActionTypes.RECEIVE_REMOTE_TASKLISTS,
    taskLists: taskLists
  };
}

function startProjectLayoutsFetch() {
  return {
    type: ActionTypes.START_PROJECTLAYOUTS_FETCH
  };
}

function receiveLocalProjectLayouts(projectLayouts) {
  return {
    type: ActionTypes.RECEIVE_LOCAL_PROJECTLAYOUTS,
    value: projectLayouts
  };
}

function receiveRemoteProjectLayouts(projectLayouts) {
  return {
    type: ActionTypes.RECEIVE_REMOTE_PROJECTLAYOUTS,
    value: projectLayouts
  };
}

function setProjectsHavePendingWrites(value) {
  return {
    type: ActionTypes.SET_PROJECTS_HAVE_PENDING_WRITES,
    value: value
  };
}

function setProjectLayoutsHavePendingWrites(value) {
  return {
    type: ActionTypes.SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES,
    value: value
  };
}

function setTaskListsHavePendingWrites(value) {
  return {
    type: ActionTypes.SET_TASKLISTS_HAVE_PENDING_WRITES,
    value: value
  };
}

function selectMuiTheme(id) {
  return {
    type: ActionTypes.SELECT_MUI_THEME,
    value: id
  };
}

function setTasksHavePendingWrites(value) {
  return {
    type: ActionTypes.SET_TASKS_HAVE_PENDING_WRITES,
    value: value
  };
}

function setIsInducting(value) {
  return {
    type: ActionTypes.SET_IS_INDUCTING,
    value: value
  };
}

function openJumpMenu() {
  return {
    type: ActionTypes.OPEN_JUMP_MENU
  };
}

function closeJumpMenu() {
  return {
    type: ActionTypes.CLOSE_JUMP_MENU
  };
}

function receiveGeneralConfig(config) {
  return {
    type: ActionTypes.RECEIVE_GENERAL_CONFIG,
    value: config
  };
}

function receiveRemoteProjectIds(ids) {
  return {
    type: ActionTypes.RECEIVE_REMOTE_PROJECT_IDS,
    value: ids
  };
}

function setUndoSnackbar(value) {
  return {
    type: ActionTypes.SET_UNDO_SNACKBAR,
    value: value
  };
}

function setShowCompletedTasks(value) {
  return {
    type: ActionTypes.SET_SHOW_COMPLETED_TASKS,
    value: value
  };
}

function receiveIncompletedLocalTasks(value) {
  return {
    type: ActionTypes.RECEIVE_INCOMPLETED_LOCAL_TASKS,
    value: value
  };
}

function setConfirmationDialog(isOpen, title, text, affirmativeButtonText, negativeButtonText, onAffirmative, onNegative) {
  return {
    type: ActionTypes.SET_CONFIRMATION_DIALOG,
    value: {
      isOpen: isOpen,
      title: title,
      text: text,
      affirmativeButtonText: affirmativeButtonText,
      negativeButtonText: negativeButtonText,
      onAffirmative: onAffirmative,
      onNegative: onNegative
    }
  };
}

function receiveCompletedLocalTasks(value) {
  return {
    type: ActionTypes.RECEIVE_COMPLETED_LOCAL_TASKS,
    value: value
  };
}

function receiveIncompletedRemoteTasks(value) {
  return {
    type: ActionTypes.RECEIVE_INCOMPLETED_REMOTE_TASKS,
    value: value
  };
}

function receiveCompletedRemoteTasks(value) {
  return {
    type: ActionTypes.RECEIVE_COMPLETED_REMOTE_TASKS,
    value: value
  };
}

function selectProject(projectId) {
  return {
    type: ActionTypes.SELECT_PROJECT,
    projectId: projectId
  };
}

function setIsProjectMenuOpen(isOpen) {
  return {
    type: ActionTypes.SET_IS_PROJECT_MENU_OPEN,
    value: isOpen
  };
}

function calculateProjectSelectorIndicators() {
  return {
    type: ActionTypes.CALCULATE_PROJECT_SELECTOR_INDICATORS
  };
}

function setIsUpdateSnackbarOpen(isOpen) {
  return {
    type: ActionTypes.SET_IS_UPDATE_SNACKBAR_OPEN,
    value: isOpen
  };
}

function startTaskCommentsGet() {
  return {
    type: ActionTypes.START_TASK_COMMENTS_GET
  };
}

function receiveTaskComments(comments) {
  return {
    type: ActionTypes.RECEIVE_TASK_COMMENTS,
    value: comments
  };
}

function setPendingTaskCommentIds(ids) {
  return {
    type: ActionTypes.SET_PENDING_TASK_COMMENT_IDS,
    value: ids
  };
}

function setIsTaskCommentsPaginating(isPaginating) {
  return {
    type: ActionTypes.SET_IS_TASK_COMMENTS_PAGINATING,
    value: isPaginating
  };
}

function setIsAllTaskCommentsFetched(isFetched) {
  return {
    type: ActionTypes.SET_IS_ALL_TASK_COMMENTS_FETCHED,
    value: isFetched
  };
}

function setSelectedProjectLayoutType(layoutType) {
  return {
    type: ActionTypes.SET_SELECTED_PROJECT_LAYOUT_TYPE,
    value: layoutType
  };
}

function receiveLocalMuiThemes(themes) {
  return {
    type: ActionTypes.RECEIVE_LOCAL_MUI_THEMES,
    value: themes
  };
} // Private Actions.


function startTaskMove(movingTaskId, sourceTaskListWidgetId) {
  return {
    type: ActionTypes.START_TASK_MOVE,
    movingTaskId: movingTaskId,
    sourceTaskListWidgetId: sourceTaskListWidgetId
  };
} // Should only be dispatched by moveTaskAsync(), as moveTaskAsync() gets the movingTaskId from the State. Calling this from elsewhere
// could create a race Condition.


function endTaskMove(movingTaskId, destinationTaskListWidgetId) {
  return {
    type: ActionTypes.END_TASK_MOVE,
    movedTaskId: movingTaskId,
    destinationTaskListWidgetId: destinationTaskListWidgetId
  };
}

function setOpenTaskInspectorId(taskId) {
  return {
    type: ActionTypes.SET_OPEN_TASK_INSPECTOR_ID,
    value: taskId
  };
} // Thunks


function bumpVersionNumberToCurrentAsync() {
  return function (dispatch, getState, _ref) {
    var getFirestore = _ref.getFirestore,
        getAuth = _ref.getAuth,
        getDexie = _ref.getDexie,
        getFunctions = _ref.getFunctions;

    var generalConfig = _objectSpread({}, getState().generalConfig);

    generalConfig.appVersion = HANDBALL_VERSION;
    dispatch(setGeneralConfigAsync(generalConfig));
  };
}

function persistMuiThemeSelection() {
  return function (dispatch, getState, _ref2) {
    var getFirestore = _ref2.getFirestore,
        getAuth = _ref2.getAuth,
        getDexie = _ref2.getDexie,
        getFunctions = _ref2.getFunctions;

    var generalConfig = _objectSpread({}, getState().generalConfig);

    generalConfig.selectedMuiThemeId = getState().selectedMuiThemeId;
    dispatch(setGeneralConfigAsync(generalConfig));
  };
}

function updateMuiThemeAsync(id, newTheme) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState, _ref3) {
        var getFirestore, getAuth, getDexie, getFunctions, muiThemes, muiTheme;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getFirestore = _ref3.getFirestore, getAuth = _ref3.getAuth, getDexie = _ref3.getDexie, getFunctions = _ref3.getFunctions;
                muiThemes = _toConsumableArray(getState().muiThemes);
                muiTheme = muiThemes.find(function (item) {
                  return item.id === id;
                });

                if (!(muiTheme === undefined)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                muiTheme.theme = newTheme;
                _context.prev = 6;
                _context.next = 9;
                return getDexie().muiThemes.update(id, {
                  theme: newTheme
                });

              case 9:
                // Add to State
                dispatch(receiveLocalMuiThemes(muiThemes));
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                console.error(_context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 12]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

function renameMuiThemeAsync(id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref5) {
        var getFirestore, getAuth, getDexie, getFunctions, muiThemes, muiTheme, dialogResult, newName;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getFirestore = _ref5.getFirestore, getAuth = _ref5.getAuth, getDexie = _ref5.getDexie, getFunctions = _ref5.getFunctions;
                muiThemes = _toConsumableArray(getState().muiThemes);
                muiTheme = muiThemes.find(function (item) {
                  return item.id === id;
                });

                if (!(muiTheme === undefined)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (!muiTheme.isInbuilt) {
                  _context2.next = 8;
                  break;
                }

                postGeneralSnackbar(dispatch, getState(), 'information', "You cannot rename a built in theme", 4000, '');
                return _context2.abrupt("return");

              case 8:
                _context2.next = 10;
                return postTextInputDialog(dispatch, getState(), 'Name', muiTheme.name, 'Rename theme');

              case 10:
                dialogResult = _context2.sent;

                if (!(dialogResult.result === 'cancel')) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return");

              case 13:
                newName = dialogResult.value;
                muiTheme.name = newName;
                _context2.prev = 15;
                _context2.next = 18;
                return getDexie().muiThemes.update(id, {
                  name: newName
                });

              case 18:
                // Update State.
                dispatch(receiveLocalMuiThemes(muiThemes));
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](15);
                postGeneralSnackbar(dispatch, getState(), 'error', "An error occured whilst renaming theme", 0, 'Dismiss');
                console.error(_context2.t0);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[15, 21]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

function removeMuiThemeAsync(id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref7) {
        var getFirestore, getAuth, getDexie, getFunctions, muiThemes, muiTheme, muiThemeIndex, themeName, dialogResult;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                getFirestore = _ref7.getFirestore, getAuth = _ref7.getAuth, getDexie = _ref7.getDexie, getFunctions = _ref7.getFunctions;
                muiThemes = _toConsumableArray(getState().muiThemes);
                muiTheme = muiThemes.find(function (item) {
                  return item.id === id;
                });
                muiThemeIndex = muiThemes.findIndex(function (item) {
                  return item.id === id;
                });

                if (!(muiTheme === undefined || muiTheme.isInbuilt === true)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                themeName = getState().muiThemes.find(function (item) {
                  return item.id === id;
                }).name;
                _context3.next = 9;
                return postConfirmationDialog(dispatch, getState(), "Are you sure you want to delete ".concat(themeName), "Delete Theme", 'Delete', 'Cancel');

              case 9:
                dialogResult = _context3.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return");

              case 12:
                dispatch(selectMuiTheme('default'));
                muiThemes.splice(muiThemeIndex, 1);
                _context3.prev = 14;
                _context3.next = 17;
                return getDexie().muiThemes["delete"](id);

              case 17:
                dispatch(receiveLocalMuiThemes(muiThemes));
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](14);
                postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured whilst deleting theme', 0, 'Dismiss');
                console.error(_context3.t0);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[14, 20]]);
      }));

      return function (_x7, _x8, _x9) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
}

function createNewMuiThemeAsync() {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref9) {
        var getFirestore, getAuth, getDexie, getFunctions, dialogResult, themeName, muiThemes, selectedMuiThemeId, selectedMuiThemeEntity, newTheme;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                getFirestore = _ref9.getFirestore, getAuth = _ref9.getAuth, getDexie = _ref9.getDexie, getFunctions = _ref9.getFunctions;
                _context4.next = 3;
                return postTextInputDialog(dispatch, getState(), 'Name', '', 'Create new Theme');

              case 3:
                dialogResult = _context4.sent;

                if (!(dialogResult.result === 'cancel')) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                themeName = dialogResult.value;
                muiThemes = _toConsumableArray(getState().muiThemes);
                selectedMuiThemeId = getState().selectedMuiThemeId;
                selectedMuiThemeEntity = muiThemes.find(function (item) {
                  return item.id === selectedMuiThemeId;
                });
                newTheme = JSON.parse(JSON.stringify(selectedMuiThemeEntity)); // Deep clone as createMuiTheme augments the color's in place.

                newTheme.id = (0, _pounderUtilities.GetUid)();
                newTheme.name = themeName;
                newTheme.isInbuilt = false; // Add to IndexedDB

                _context4.prev = 14;
                _context4.next = 17;
                return getDexie().muiThemes.add(newTheme);

              case 17:
                // Add to State.
                muiThemes.push(newTheme);
                dispatch(receiveLocalMuiThemes(muiThemes));
                dispatch(selectMuiTheme(newTheme.id));
                _context4.next = 26;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](14);
                postGeneralSnackbar(dispatch, getState(), 'error', "An error occured whilst creating new Theme", 0, 'Dismiss');
                console.error(_context4.t0);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[14, 22]]);
      }));

      return function (_x10, _x11, _x12) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
}

function getLocalMuiThemes() {
  return (
    /*#__PURE__*/
    function () {
      var _ref12 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(dispatch, getState, _ref11) {
        var getFirestore, getAuth, getDexie, getFunctions, muiThemes;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                getFirestore = _ref11.getFirestore, getAuth = _ref11.getAuth, getDexie = _ref11.getDexie, getFunctions = _ref11.getFunctions;
                _context5.prev = 1;
                _context5.next = 4;
                return getDexie().muiThemes.toArray();

              case 4:
                muiThemes = _context5.sent;
                dispatch(receiveLocalMuiThemes(muiThemes));
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](1);
                postGeneralSnackbar(dispatch, getState(), 'error', "An error occured whilst retrieving Local themes", 0, "Dismiss");
                console.error(_context5.t0);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 8]]);
      }));

      return function (_x13, _x14, _x15) {
        return _ref12.apply(this, arguments);
      };
    }()
  );
}

function startTaskMoveAsync(taskId, sourceTaskListId) {
  return function (dispatch, getState, _ref13) {
    var getFirestore = _ref13.getFirestore,
        getAuth = _ref13.getAuth,
        getDexie = _ref13.getDexie,
        getFunctions = _ref13.getFunctions;
    postGeneralSnackbar(dispatch, getState(), 'information', 'Touch the desired list for the Task', 4000, '');
    dispatch(startTaskMove(taskId, sourceTaskListId));
  };
}

function moveTaskListToProjectAsync(taskListId, sourceProjectId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref15 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(dispatch, getState, _ref14) {
        var getFirestore, getAuth, getDexie, getFunctions, otherProjects, items, dialogResult, targetProjectId, batch, taskIds, taskListRef, currentLayouts, filteredLayouts, payload, job, jobRef, refs, tasks, taskList;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                getFirestore = _ref14.getFirestore, getAuth = _ref14.getAuth, getDexie = _ref14.getDexie, getFunctions = _ref14.getFunctions;
                otherProjects = getState().projects.filter(function (item) {
                  return item.uid !== sourceProjectId;
                });
                items = otherProjects.map(function (item) {
                  return {
                    primaryText: item.projectName,
                    value: item.uid
                  };
                });
                _context6.next = 5;
                return postItemSelectDialog(dispatch, getState(), 'Move List', 'Choose project', items, "Move", "Cancel");

              case 5:
                dialogResult = _context6.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return");

              case 8:
                targetProjectId = dialogResult.value;

                if (!isProjectRemote(getState, sourceProjectId) && !isProjectRemote(getState, targetProjectId)) {
                  // Both Projects are Local.
                  batch = new _firestoreBatchPaginator["default"](getFirestore()); // Move Tasks.

                  taskIds = collectTaskListRelatedTaskIds(getState().tasks, taskListId);
                  taskIds.forEach(function (id) {
                    var ref = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS).doc(id);
                    batch.update(ref, {
                      project: targetProjectId
                    });
                  }); // Move Task List.

                  taskListRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc(taskListId);
                  batch.update(taskListRef, {
                    project: targetProjectId
                  }); // Move Layout.

                  currentLayouts = getState().projectLayoutsMap[sourceProjectId][sourceProjectId].layouts;

                  if (currentLayouts) {
                    filteredLayouts = currentLayouts.filter(function (item) {
                      return item.i !== taskListId;
                    });
                    dispatch(updateProjectLayoutAsync(filteredLayouts, currentLayouts, sourceProjectId));
                    addProjectLayoutEntriesToBatch(batch, targetProjectId, taskListId, getFirestore, getState);
                  }

                  payload = {
                    targetProjectId: targetProjectId,
                    taskListWidgetId: taskListId,
                    sourceTasksRefPath: getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS).path
                  };
                  job = (0, _pounderStores.JobFactory)(JobTypes.CLEANUP_LOCAL_TASKLIST_MOVE, payload);
                  jobRef = getFirestore().collection(_paths.JOBS_QUEUE).doc();
                  batch.set(jobRef, job);
                  batch.commit().then(function () {// Success
                  })["catch"](function (error) {
                    handleFirebaseUpdateError(error, getState(), dispatch);
                  });
                  dispatch(selectProject(targetProjectId));
                } else {
                  // One or both projects are Remote.
                  batch = new _firestoreBatchPaginator["default"](getFirestore());
                  refs = buildTaskListMoveRefs(sourceProjectId, targetProjectId, taskListId, getFirestore, getState); // Move Tasks

                  tasks = collectTaskListRelatedTasks(getState().tasks, taskListId);
                  tasks.forEach(function (task) {
                    batch.set(refs.target.tasks.doc(task.uid), _objectSpread({}, task, {
                      project: targetProjectId
                    }));
                    batch["delete"](refs.source.tasks.doc(task.uid));
                  }); // Move Task List.

                  taskList = getState().taskLists.find(function (item) {
                    return item.uid === taskListId;
                  });
                  batch.set(refs.target.taskList, _objectSpread({}, taskList, {
                    project: targetProjectId
                  }));
                  batch.update(refs.source.taskList, {
                    isMoving: true
                  }); // Move Project Layouts.

                  addProjectLayoutMovesToBatch(batch, sourceProjectId, targetProjectId, taskListId, getFirestore, getState); // Create a Cleanup Job for the Server.

                  payload = {
                    sourceProjectId: sourceProjectId,
                    targetProjectId: targetProjectId,
                    taskListWidgetId: taskListId,
                    taskIds: collectTaskListRelatedTaskIds(getState().tasks, taskListId),
                    targetTasksRefPath: refs.target.tasks.path,
                    targetTaskListRefPath: refs.target.taskList.path,
                    sourceTasksRefPath: refs.source.tasks.path,
                    sourceTaskListRefPath: refs.source.taskList.path
                  };
                  job = (0, _pounderStores.JobFactory)(JobTypes.CLEANUP_REMOTE_TASKLIST_MOVE, payload);
                  jobRef = getFirestore().collection(_paths.JOBS_QUEUE).doc();
                  batch.set(jobRef, job);
                  batch.commit().then(function () {// Success
                  })["catch"](function (error) {
                    handleFirebaseUpdateError(error, getState(), dispatch);
                  });
                  dispatch(selectProject(targetProjectId));
                }

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x16, _x17, _x18) {
        return _ref15.apply(this, arguments);
      };
    }()
  );
}

function updateProjectLayoutTypeAsync(projectLayoutType) {
  return function (dispatch, getState, _ref16) {
    var getFirestore = _ref16.getFirestore,
        getAuth = _ref16.getAuth,
        getDexie = _ref16.getDexie,
        getFunctions = _ref16.getFunctions;
    var selectedProjectId = getState().selectedProjectId;

    if (isProjectRemote(getState, selectedProjectId) === true) {
      var batch = getFirestore().batch();
      var memberRef = getFirestore().collection(_paths.REMOTES).doc(selectedProjectId).collection(_paths.MEMBERS).doc((0, _pounderFirebase.getUserUid)());
      batch.update(memberRef, {
        projectLayoutType: projectLayoutType
      });

      if (hasUserGotALocalLayout(getState()) === false) {
        // If user has not already been in "Local" project layout mode. Create a new Layout entry for them.
        var projectLayoutRef = getProjectLayoutRef(getFirestore, getState, selectedProjectId).doc((0, _pounderFirebase.getUserUid)());
        var existingLayouts = getState().selectedProjectLayout.layouts;
        batch.set(projectLayoutRef, _objectSpread({}, new _pounderStores.ProjectLayoutStore(existingLayouts, selectedProjectId, (0, _pounderFirebase.getUserUid)())));
      }

      batch.commit().then(function () {// Success
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      }); // Update State.

      dispatch(setSelectedProjectLayoutType(projectLayoutType));
    }
  };
}

function openTaskInspector(taskId) {
  return function (dispatch, getState, _ref17) {
    var getFirestore = _ref17.getFirestore,
        getAuth = _ref17.getAuth,
        getDexie = _ref17.getDexie,
        getFunctions = _ref17.getFunctions;
    dispatch(setOpenTaskInspectorId(taskId));
  };
}

function closeTaskInspectorAsync() {
  return function (dispatch, getState, _ref18) {
    var getFirestore = _ref18.getFirestore,
        getAuth = _ref18.getAuth,
        getDexie = _ref18.getDexie,
        getFunctions = _ref18.getFunctions;
    // Save some Info before it is destroyed by the closeTaskInfo() Action.
    var openTaskInspectorId = getState().openTaskInspectorId;

    var openTaskInspectorEntity = _objectSpread({}, getState().openTaskInspectorEntity);

    var allTaskComments = [].concat(_toConsumableArray(openTaskInspectorEntity.commentPreview), _toConsumableArray(getState().taskComments));

    var newCommentPreview = _toConsumableArray(openTaskInspectorEntity.commentPreview);

    var selectedProjectId = getState().selectedProjectId;
    var taskRef = getFirestore().collection(_paths.REMOTES).doc(selectedProjectId).collection(_paths.TASKS).doc(openTaskInspectorId);
    dispatch(setOpenTaskInspectorId(-1));
    dispatch(setIsAllTaskCommentsFetched(false)); // Add User ID to Seenby of any Unseen Task Comments or Comment Preview.

    if (isProjectRemote(getState, selectedProjectId) === true) {
      var batch = getFirestore().batch();
      var unseenCommentsFound = false;
      allTaskComments.forEach(function (comment) {
        // Comment is Unseen.
        if (!comment.seenBy.includes((0, _pounderFirebase.getUserUid)())) {
          unseenCommentsFound = true;
          var ref = getFirestore().collection(_paths.REMOTES).doc(selectedProjectId).collection(_paths.TASKS).doc(openTaskInspectorId).collection(_paths.TASKCOMMENTS).doc(comment.uid);
          var newSeenBy = comment.seenBy;
          newSeenBy.push((0, _pounderFirebase.getUserUid)()); // Update Comment Reference.

          batch.update(ref, {
            seenBy: newSeenBy
          }); // Update Comment Preview.

          var index = newCommentPreview.findIndex(function (item) {
            item.uid === comment.uid;
          });

          if (index !== -1 && newCommentPreview[index].seenBy.includes((0, _pounderFirebase.getUserUid)()) === false) {
            newCommentPreview[index].seenBy.push((0, _pounderFirebase.getUserUid)());
          }
        }
      });
      batch.update(taskRef, {
        commentPreview: newCommentPreview
      });
      batch.commit().then(function () {// Success
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      }); // Update Task.unseenTaskCommentMembers if unseen Comments have been found.

      if (unseenCommentsFound === true) {
        taskRef.get().then(function (doc) {
          if (doc.exists) {
            // Filter out current User from unseenCommentMembers.
            var currentUnseenCommentMembers = doc.data().unseenTaskCommentMembers;
            var newUnseenCommentMembers = {};

            for (var propertyName in currentUnseenCommentMembers) {
              if (propertyName !== (0, _pounderFirebase.getUserUid)()) {
                newUnseenCommentMembers[propertyName] = "0";
              }
            }

            taskRef.update({
              unseenTaskCommentMembers: newUnseenCommentMembers
            }).then(function () {})["catch"](function (error) {
              handleFirebaseUpdateError(error, getState(), dispatch);
            });
          }
        })["catch"](function (error) {
          handleFirebaseSnapshotError(error, getState(), dispatch);
        });
      } // Update Comment Preview if it contains unseenComments.


      var previewHasUnseenComments = openTaskInspectorEntity.commentPreview.some(function (comment) {
        return comment.seenBy.includes((0, _pounderFirebase.getUserUid)());
      });

      if (previewHasUnseenComments) {
        var _newCommentPreview = _toConsumableArray(openTaskInspectorEntity.commentPreview);

        _newCommentPreview.forEach(function (item) {
          if (item.seenBy.includes((0, _pounderFirebase.getUserUid)()) === false) {
            item.seenBy.push((0, _pounderFirebase.getUserUid)());
          }
        });

        taskRef.update({
          commentPreview: _newCommentPreview
        }).then(function () {})["catch"](function (error) {
          handleFirebaseUpdateError(error, getState(), dispatch);
        });
      }
    }
  };
}

function getTaskCommentsAsync(taskId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref20 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(dispatch, getState, _ref19) {
        var getFirestore, getAuth, getDexie, getFunctions, ref, snapshot;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                getFirestore = _ref19.getFirestore, getAuth = _ref19.getAuth, getDexie = _ref19.getDexie, getFunctions = _ref19.getFunctions;
                dispatch(startTaskCommentsGet());
                ref = getTaskRef(getFirestore, getState, taskId).collection(_paths.TASKCOMMENTS).orderBy("timestamp", "desc").limit(_pounderFirebase.TaskCommentQueryLimit + 1);
                _context7.prev = 3;
                _context7.next = 6;
                return ref.get();

              case 6:
                snapshot = _context7.sent;
                handleTaskCommentsSnapshot("initial", snapshot, dispatch);
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](3);
                handleFirebaseSnapshotError(_context7.t0, getState(), dispatch, getState);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[3, 10]]);
      }));

      return function (_x19, _x20, _x21) {
        return _ref20.apply(this, arguments);
      };
    }()
  );
}

function paginateTaskCommentsAsync(taskId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref22 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(dispatch, getState, _ref21) {
        var getFirestore, getAuth, getDexie, getFunctions, previousQueryLastDoc, ref, snapshot;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                getFirestore = _ref21.getFirestore, getAuth = _ref21.getAuth, getDexie = _ref21.getDexie, getFunctions = _ref21.getFunctions;

                if (!(getState().taskComments.length > 0)) {
                  _context8.next = 17;
                  break;
                }

                previousQueryLastDoc = getState().taskComments[getState().taskComments.length - 1].doc;

                if (!(previousQueryLastDoc !== undefined)) {
                  _context8.next = 17;
                  break;
                }

                dispatch(setIsTaskCommentsPaginating(true));
                ref = getTaskRef(getFirestore, getState, taskId).collection(_paths.TASKCOMMENTS).orderBy("timestamp", "desc").startAfter(previousQueryLastDoc).limit(_pounderFirebase.TaskCommentQueryLimit + 1);
                _context8.prev = 6;
                _context8.next = 9;
                return ref.get();

              case 9:
                snapshot = _context8.sent;
                handleTaskCommentsSnapshot("pagination", snapshot, dispatch, getState);
                dispatch(setIsTaskCommentsPaginating(false));
                _context8.next = 17;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](6);
                handleFirebaseSnapshotError(_context8.t0, getState(), dispatch, getState);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[6, 14]]);
      }));

      return function (_x22, _x23, _x24) {
        return _ref22.apply(this, arguments);
      };
    }()
  );
}

function deleteTaskCommentAsync(taskId, commentId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref24 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee9(dispatch, getState, _ref23) {
        var getFirestore, getAuth, getDexie, getFunctions, newTaskComments, batch, taskRef, commentRef;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                getFirestore = _ref23.getFirestore, getAuth = _ref23.getAuth, getDexie = _ref23.getDexie, getFunctions = _ref23.getFunctions;
                // Update State.
                newTaskComments = getState().taskComments.filter(function (item) {
                  return item.uid !== commentId;
                });
                dispatch(receiveTaskComments(newTaskComments));
                batch = getFirestore().batch();
                taskRef = getTaskRef(getFirestore, getState, taskId);
                commentRef = taskRef.collection(_paths.TASKCOMMENTS).doc(commentId);
                batch.update(taskRef, {
                  commentPreview: generateNewCommentPreview(newTaskComments)
                });
                batch["delete"](commentRef);
                _context9.prev = 8;
                _context9.next = 11;
                return batch.commit();

              case 11:
                _context9.next = 16;
                break;

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9["catch"](8);
                handleFirebaseUpdateError(_context9.t0, getState(), dispatch);

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[8, 13]]);
      }));

      return function (_x25, _x26, _x27) {
        return _ref24.apply(this, arguments);
      };
    }()
  );
}

function handleTaskCommentsSnapshot(type, snapshot, dispatch, getState) {
  var taskComments = [];
  var counter = 0;
  snapshot.forEach(function (doc) {
    // Take only enough Comments to equal TaskCommentQueryLimit. comment[TaskCommentQueryLimit + 1] is only used to
    // determine if Pagination is completed.
    if (counter < _pounderFirebase.TaskCommentQueryLimit) {
      var comment = _objectSpread({
        doc: doc,
        isSynced: !doc.metadata.hasPendingWrites
      }, doc.data());

      taskComments.push(comment);
      counter++;
    }
  });

  if (snapshot.size < _pounderFirebase.TaskCommentQueryLimit + 1) {
    dispatch(setIsAllTaskCommentsFetched(true));
  }

  if (type === "initial") {
    // Send to state as is.
    dispatch(receiveTaskComments(taskComments));
  }

  if (type === "pagination") {
    // Concat with existing Task Comments.
    var mergedTaskComments = [].concat(_toConsumableArray(getState().taskComments), taskComments);
    dispatch(receiveTaskComments(mergedTaskComments));
  }
}

function generateNewCommentPreview(fullComments) {
  var comments = _toConsumableArray(fullComments);

  var startIndex = 0;
  var endIndex = _pounderFirebase.TaskCommentPreviewLimit;
  var previewComments = comments.slice(startIndex, endIndex); // Strip out doc objects and add this user to Seenby.

  return previewComments.map(function (item) {
    var returnItem = _objectSpread({}, item);

    delete returnItem.doc; // Delete Doc reference.

    if (returnItem.seenBy.find(function (id) {
      return id === (0, _pounderFirebase.getUserUid)();
    }) === undefined) {
      returnItem.seenBy.push((0, _pounderFirebase.getUserUid)());
    }

    return returnItem;
  });
}

function postNewCommentAsync(taskId, value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref26 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee10(dispatch, getState, _ref25) {
        var getFirestore, getAuth, getDexie, getFunctions, selectedProjectId, mentions, created, createdBy, displayName, seenBy, taskRef, newCommentRef, taskComment, existingComments, batch, unseenMembersArray, unseenMembers, commentIndex, comments;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                getFirestore = _ref25.getFirestore, getAuth = _ref25.getAuth, getDexie = _ref25.getDexie, getFunctions = _ref25.getFunctions;
                selectedProjectId = getState().selectedProjectId;
                mentions = [];
                created = (0, _moment["default"])().toISOString();
                createdBy = (0, _pounderFirebase.getUserUid)();
                displayName = getState().displayName;
                seenBy = [createdBy];
                taskRef = getTaskRef(getFirestore, getState, taskId);
                newCommentRef = taskRef.collection(_paths.TASKCOMMENTS).doc();
                taskComment = (0, _pounderStores.TaskCommentFactory)(newCommentRef.id, value, mentions, created, createdBy, seenBy, displayName); // Add to State.

                existingComments = _toConsumableArray(getState().taskComments);
                existingComments.unshift(_objectSpread({
                  isSynced: false
                }, taskComment));
                dispatch(receiveTaskComments(existingComments)); // Add to Database.

                batch = getFirestore().batch();
                batch.set(newCommentRef, taskComment); // Comment into Comment Collection.

                batch.update(taskRef, {
                  commentPreview: generateNewCommentPreview(existingComments)
                }); // Comment into Comment Preview collection.
                // Add a Hashtable to Task to indicate the User ID's that have unseen Comments.
                // Also add a flag to indicate this Task may have Comments. This helps the Migration Functions.

                unseenMembersArray = getState().members.filter(function (item) {
                  return item.project === selectedProjectId && item.userId !== createdBy;
                });
                unseenMembers = {};
                unseenMembersArray.forEach(function (item) {
                  unseenMembers[item.userId] = "0";
                });
                batch.update(taskRef, {
                  unseenTaskCommentMembers: unseenMembers,
                  mightHaveTaskComments: true
                });
                _context10.prev = 20;
                _context10.next = 23;
                return batch.commit();

              case 23:
                // Success. Update newly posted comment's isSynced flag.
                commentIndex = getState().taskComments.findIndex(function (item) {
                  return item.uid === newCommentRef.id;
                });

                if (commentIndex !== -1) {
                  comments = _toConsumableArray(getState().taskComments);
                  comments[commentIndex].isSynced = true;
                  dispatch(receiveTaskComments(comments));
                }

                _context10.next = 30;
                break;

              case 27:
                _context10.prev = 27;
                _context10.t0 = _context10["catch"](20);
                handleFirebaseUpdateError(_context10.t0, getState(), dispatch);

              case 30:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[20, 27]]);
      }));

      return function (_x28, _x29, _x30) {
        return _ref26.apply(this, arguments);
      };
    }()
  );
}

function manuallyRenewChecklistAsync(taskListId) {
  return function (dispatch, getState, _ref27) {
    var getFirestore = _ref27.getFirestore,
        getAuth = _ref27.getAuth,
        getDexie = _ref27.getDexie,
        getFunctions = _ref27.getFunctions;
    var taskList = extractTaskList(taskListId, getState().taskLists);

    if (taskList === undefined) {
      return;
    }

    var projectId = taskList.project;
    var isRemote = isProjectRemote(getState, projectId);
    dispatch(renewChecklistAsync(taskList, isRemote, projectId, true));
  };
}

function renewChecklistAsync(taskList, isRemote, projectId, userTriggered) {
  return function (dispatch, getState, _ref28) {
    var getFirestore = _ref28.getFirestore,
        getAuth = _ref28.getAuth,
        getDexie = _ref28.getDexie,
        getFunctions = _ref28.getFunctions;
    var taskListId = taskList.uid;
    var tasksCollectionRef = isRemote === true ? getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKS) : getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS);
    tasksCollectionRef.where("taskList", "==", taskListId).get().then(function (snapshot) {
      var taskRefs = [];
      snapshot.forEach(function (doc) {
        taskRefs.push(doc.ref);
      });
      var batch = getFirestore().batch();
      taskRefs.forEach(function (ref) {
        batch.update(ref, {
          isComplete: false
        });
      }); // Update the settings to represent the next requested renew Time, but only if this wasn't triggered by the user.
      // User triggering could be from the "Renew Now" button. 

      if (userTriggered !== true) {
        var taskListRef = isRemote === true ? getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKLISTS).doc(taskListId) : getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc(taskListId);

        var newChecklistSettings = _objectSpread({}, taskList.settings.checklistSettings, {
          lastRenewDate: (0, _pounderUtilities.getNormalizedDate)((0, _moment["default"])())
        });

        var newTaskListSettings = _objectSpread({}, taskList.settings, {
          checklistSettings: newChecklistSettings
        });

        batch.update(taskListRef, {
          settings: newTaskListSettings
        });
      }

      batch.commit().then(function () {// Success
      });
    });
  };
}

function getNewRenewDate(currentRenewDate, renewInterval) {
  var newRenewMoment = (0, _moment["default"])(currentRenewDate).add(renewInterval, 'days');
  return (0, _pounderUtilities.getNormalizedDate)(newRenewMoment);
}

function setShowCompletedTasksAsync(showCompletedTasks) {
  return function (dispatch, getState, _ref29) {
    var getFirestore = _ref29.getFirestore,
        getAuth = _ref29.getAuth,
        getDexie = _ref29.getDexie,
        getFunctions = _ref29.getFunctions;

    if (showCompletedTasks !== getState().showCompletedTasks) {
      dispatch(setShowCompletedTasks(showCompletedTasks));

      if (showCompletedTasks) {
        // Local
        dispatch(getCompletedLocalTasksAsync()); // Remote.

        if (getState().isSelectedProjectRemote) {
          var selectedProjectId = getState().selectedProjectId;
          var remoteProjectUnsubscribe = remoteProjectsUnsubscribes[selectedProjectId];

          if (remoteProjectUnsubscribe !== undefined) {
            remoteProjectUnsubscribe.onlyCompletedTasks = getCompletedRemoteTasks(getFirestore, getState, dispatch, selectedProjectId);
          }
        }
      } else {
        unsubscribeCompletedTasks();
        dispatch(receiveCompletedLocalTasks([]));
        dispatch(receiveCompletedRemoteTasks([]));
      }
    }
  };
}

function unsubscribeCompletedTasks() {
  // Local.
  // Unsubscribe from changes and Clear Local State.
  if (onlyCompletedLocalTasksUnsubscribe !== null) {
    onlyCompletedLocalTasksUnsubscribe();
  } // Remote.
  // Unsubscribe from changes and clear Local state.

  /*
      Why unsubscribe from every remote project? We are trying to avoid having to use getState or getFirestore so that we can
      consume this method outside of a Thunk.
  */


  for (var projectId in remoteProjectsUnsubscribes) {
    if (remoteProjectsUnsubscribes[projectId].onlyCompletedTasks !== null) {
      remoteProjectsUnsubscribes[projectId].onlyCompletedTasks();
    }
  }
}

function updateTaskNoteAsync(newValue, oldValue, taskId) {
  return function (dispatch, getState, _ref30) {
    var getFirestore = _ref30.getFirestore,
        getAuth = _ref30.getAuth,
        getDexie = _ref30.getDexie,
        getFunctions = _ref30.getFunctions;

    if (oldValue !== newValue) {
      var taskRef = getTaskRef(getFirestore, getState, taskId);
      taskRef.update({
        note: newValue,
        metadata: getUpdatedMetadata(extractCurrentMetadata(getState(), taskId), {
          updatedBy: getState().displayName,
          updatedOn: getHumanFriendlyDate()
        })
      }).then(function () {// Careful what you do here, Promises don't resolve Offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      }); // Project updated metadata.

      updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
    }
  };
}

function updateTaskAssignedToAsync(newUserId, oldUserId, taskId) {
  return function (dispatch, getState, _ref31) {
    var getFirestore = _ref31.getFirestore,
        getAuth = _ref31.getAuth,
        getDexie = _ref31.getDexie,
        getFunctions = _ref31.getFunctions;

    if (newUserId !== oldUserId) {
      var taskRef = getTaskRef(getFirestore, getState, taskId);
      taskRef.update({
        assignedTo: newUserId
      }).then(function () {// Careful what you do here, Promises don't resolve Offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      }); // Project updated metadata.

      updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
    }
  };
}

function sendPasswordResetEmailAsync() {
  return function (dispatch, getState, _ref32) {
    var getFirestore = _ref32.getFirestore,
        getAuth = _ref32.getAuth,
        getDexie = _ref32.getDexie,
        getFunctions = _ref32.getFunctions;
    var email = getState().userEmail;
    getAuth().sendPasswordResetEmail(email).then(function () {
      postGeneralSnackbar(dispatch, getState(), 'information', 'Password reset email sent', 4000, '');
    })["catch"](function (error) {
      postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + error.message, 0, 'Dismiss');
    });
  };
}

function registerNewUserAsync(email, password, displayName) {
  return (
    /*#__PURE__*/
    function () {
      var _ref34 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee11(dispatch, getState, _ref33) {
        var getFirestore, getAuth, getDexie, getFunctions, parsedEmail;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                getFirestore = _ref33.getFirestore, getAuth = _ref33.getAuth, getDexie = _ref33.getDexie, getFunctions = _ref33.getFunctions;

                if (!(displayName === "")) {
                  _context11.next = 5;
                  break;
                }

                postGeneralSnackbar(dispatch, getState(), 'information', 'Please enter a Display Name', 4000, '');
                _context11.next = 27;
                break;

              case 5:
                dispatch(setIsLoggingInFlag(true));
                parsedEmail = email.toLowerCase().trim(); // Save the users details so they can be pushed to the Directory once they are logged in. This is because we can't set
                // a cloud function trigger to watch for a profile update, we also can't provide the display name along with the
                // createUserWithEmailAndPassword function, so this is the current best way to set a directory entry without concurrency
                // issues.

                newUser = {
                  email: parsedEmail,
                  displayName: displayName
                };
                _context11.prev = 8;
                _context11.next = 11;
                return getAuth().createUserWithEmailAndPassword(parsedEmail, password);

              case 11:
                _context11.prev = 11;
                _context11.next = 14;
                return getAuth().currentUser.updateProfile({
                  displayName: displayName
                });

              case 14:
                dispatch(setDisplayName(displayName));
                _context11.next = 21;
                break;

              case 17:
                _context11.prev = 17;
                _context11.t0 = _context11["catch"](11);
                handleFirebaseUpdateError(_context11.t0, getState(), dispatch);
                newUser = null;

              case 21:
                _context11.next = 27;
                break;

              case 23:
                _context11.prev = 23;
                _context11.t1 = _context11["catch"](8);
                handleAuthError(dispatch, getState(), _context11.t1);
                dispatch(setIsLoggingInFlag(false));

              case 27:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[8, 23], [11, 17]]);
      }));

      return function (_x31, _x32, _x33) {
        return _ref34.apply(this, arguments);
      };
    }()
  );
}

function clearFirstTimeBootFlag(dispatch, getState) {
  var generalConfig = getState().generalConfig;
  generalConfig.isFirstTimeBoot = false;
  dispatch(setGeneralConfigAsync(generalConfig));
}

function acceptProjectInviteAsync(projectId) {
  return function (dispatch, getState, _ref35) {
    var getFirestore = _ref35.getFirestore,
        getAuth = _ref35.getAuth,
        getDexie = _ref35.getDexie,
        getFunctions = _ref35.getFunctions;
    addUpdatingInviteId(dispatch, getState, projectId);
    var acceptProjectInvite = getFunctions().httpsCallable('acceptProjectInvite');
    acceptProjectInvite({
      projectId: projectId
    }).then(function () {
      var inviteRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.INVITES).doc(projectId);
      inviteRef["delete"]().then(function () {
        // Success.
        removeUpdatingInviteId(dispatch, getState, projectId);
      })["catch"](function (error) {
        dispatch(handleFirebaseUpdateError(error, getState(), dispatch));
        removeUpdatingInviteId(dispatch, getState, projectId);
      });
    })["catch"](function (error) {
      var message = "An Error occured, are you sure you are connected to the internet? Error Message : ".concat(error.message);
      postGeneralSnackbar(dispatch, getState(), 'error', message, 0, 'Dismiss');
      removeUpdatingInviteId(dispatch, getState, projectId);
    });
  };
}

function denyProjectInviteAsync(projectId) {
  return function (dispatch, getState, _ref36) {
    var getFirestore = _ref36.getFirestore,
        getAuth = _ref36.getAuth,
        getDexie = _ref36.getDexie,
        getFunctions = _ref36.getFunctions;
    addUpdatingInviteId(dispatch, getState, projectId); // Success.

    var denyProjectInvite = getFunctions().httpsCallable('denyProjectInvite');
    denyProjectInvite({
      projectId: projectId
    }).then(function (result) {
      if (result.data.status === 'error') {
        postGeneralSnackbar(dispatch, getState(), 'error', result.data.message, 0, 'Dismiss');
        removeUpdatingInviteId(dispatch, getState, projectId);
      } else {
        // Success.
        var inviteRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.INVITES).doc(projectId);
        inviteRef["delete"]().then(function () {
          removeUpdatingInviteId(dispatch, getState, projectId);
        })["catch"](function (error) {
          dispatch(handleFirebaseUpdateError(error, getState(), dispatch));
        });
      }
    })["catch"](function (error) {
      var message = "An Error occured, are you sure you are connected to the internet? Error Message : ".concat(error.message);
      postGeneralSnackbar(dispatch, getState(), 'error', message, 7000, '');
      removeUpdatingInviteId(dispatch, getState, projectId);
    });
  };
}

function getRemoteProjectIdsAsync() {
  return function (dispatch, getState, _ref37) {
    var getFirestore = _ref37.getFirestore,
        getAuth = _ref37.getAuth,
        getDexie = _ref37.getDexie,
        getFunctions = _ref37.getFunctions;
    getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.REMOTE_IDS).onSnapshot(function (snapshot) {
      if (snapshot.docChanges().length > 0) {
        var remoteProjectIds = [];
        snapshot.forEach(function (doc) {
          remoteProjectIds.push(doc.data().projectId);
        });
        dispatch(receiveRemoteProjectIds(remoteProjectIds));
        snapshot.docChanges().forEach(function (change) {
          if (change.type === "added") {
            dispatch(subscribeToRemoteProjectAsync(change.doc.data().projectId));
          }

          if (change.type === "removed") {
            dispatch(unsubscribeFromRemoteProjectAsync(change.doc.data().projectId));
          }
        });
      }
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function subscribeToRemoteProjectAsync(projectId) {
  return function (dispatch, getState, _ref38) {
    var getFirestore = _ref38.getFirestore,
        getAuth = _ref38.getAuth,
        getDexie = _ref38.getDexie,
        getFunctions = _ref38.getFunctions;
    // Top Level Project Info.
    var projectUnsubscribe = getFirestore().collection(_paths.REMOTES).doc(projectId).onSnapshot(function (doc) {
      if (doc.exists) {
        var projectName = doc.get('projectName');
        var members = doc.get('members');
        var created = doc.get('created');
        var updated = doc.get('updated');
        var filteredProjects = getState().remoteProjects.filter(function (item) {
          return item.uid !== doc.id;
        });
        filteredProjects.push({
          projectName: projectName,
          members: members,
          uid: doc.id,
          isRemote: true,
          created: created,
          updated: updated
        });
        dispatch(receiveRemoteProjects(filteredProjects));
      }
    }); // Members.

    var membersUnsubscribe = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.MEMBERS).onSnapshot(function (snapshot) {
      handleMembersSnapshot(getState, dispatch, snapshot, projectId);
    }); // TaskLists.

    var taskListsUnsubscribe = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKLISTS).onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      handleTaskListsSnapshot(getState, dispatch, true, snapshot, projectId);
    }); // Tasks.
    // Always get Incompleted Tasks.

    var onlyIncompletedRemoteTasksUnsubscribe = getIncompletedRemoteTasks(getFirestore, getState, dispatch, projectId); // Only get completed tasks if we have to.

    var onlyCompletedRemoteTasksUnsubscribe = getState().showCompletedTasks ? getCompletedRemoteTasks(getFirestore, getState, dispatch, projectId) : null; // ProjectLayout.

    var projectLayoutUnsubscribe = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.PROJECTLAYOUTS).onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      handleProjectLayoutsSnapshot(getState, dispatch, true, snapshot, projectId);
    });
    remoteProjectsUnsubscribes[projectId] = {
      project: projectUnsubscribe,
      members: membersUnsubscribe,
      taskLists: taskListsUnsubscribe,
      onlyIncompletedTasks: onlyIncompletedRemoteTasksUnsubscribe,
      onlyCompletedTasks: onlyCompletedRemoteTasksUnsubscribe,
      projectLayout: projectLayoutUnsubscribe
    };
  };
}

function getCompletedRemoteTasks(getFirestore, getState, dispatch, projectId) {
  return getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKS).where('isComplete', '==', true).orderBy('project').onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
    handleTasksSnapshot(getState, dispatch, true, snapshot, projectId, 'completedOnly');
  });
}

function getIncompletedRemoteTasks(getFirestore, getState, dispatch, projectId) {
  return getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKS).where('isComplete', '==', false).orderBy('project').onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
    handleTasksSnapshot(getState, dispatch, true, snapshot, projectId, 'incompletedOnly');
  });
}

function handleMembersSnapshot(getState, dispatch, snapshot, projectId) {
  if (snapshot.docChanges().length > 0) {
    var currentMembers = getState().members;
    var filteredMembers = currentMembers.filter(function (item) {
      return item.project !== projectId;
    });
    snapshot.forEach(function (doc) {
      filteredMembers.push(doc.data());
    });
    dispatch(receiveMembers(filteredMembers));
  }
}

function unsubscribeFromRemoteProjectAsync(projectId) {
  return function (dispatch, getState, _ref39) {
    var getFirestore = _ref39.getFirestore,
        getAuth = _ref39.getAuth,
        getDexie = _ref39.getDexie,
        getFunctions = _ref39.getFunctions;
    // Project.
    remoteProjectsUnsubscribes[projectId].project; // Extract and remove from State.

    var remoteProjects = getState().remoteProjects.filter(function (item) {
      return item.uid !== projectId;
    });
    dispatch(receiveRemoteProjects(remoteProjects)); // Members.

    remoteProjectsUnsubscribes[projectId].members(); // Extract and remove from state.

    var filteredMembers = getState().members.filter(function (item) {
      return item.project !== projectId;
    });
    dispatch(receiveMembers(filteredMembers)); // TaskLists.

    remoteProjectsUnsubscribes[projectId].taskLists(); // Extract and remove from state.

    var taskLists = getState().remoteTaskLists.filter(function (item) {
      return item.project !== projectId;
    });
    dispatch(receiveRemoteTaskLists(taskLists)); // Tasks.

    if (remoteProjectsUnsubscribes[projectId].onlyIncompletedTasks !== null) {
      remoteProjectsUnsubscribes[projectId].onlyIncompletedTasks();
    }

    if (remoteProjectsUnsubscribes[projectId].onlyCompletedTasks !== null) {
      remoteProjectsUnsubscribes[projectId].onlyCompletedTasks;
    } // Extract and remove from state.


    var incompletedTasks = getState().incompletedRemoteTasks.filter(function (item) {
      return item.project !== projectId;
    });
    dispatch(receiveIncompletedRemoteTasks(incompletedTasks));

    if (getState().showCompletedTasks) {
      var completedTasks = getState().completedRemoteTasks.filter(function (item) {
        return item.project !== projectId;
      });
      dispatch(receiveCompletedRemoteTasks(completedTasks));
    } // ProjectLayout.


    remoteProjectsUnsubscribes[projectId].projectLayout(); // Extract and remove from state.

    var projectLayouts = getState().remoteProjectLayouts.filter(function (item) {
      return item.project !== projectId;
    });
    dispatch(receiveRemoteProjectLayouts(projectLayouts));
  };
}

function migrateProjectBackToLocalAsync(projectId, preCondition) {
  return (
    /*#__PURE__*/
    function () {
      var _ref41 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee12(dispatch, getState, _ref40) {
        var getFirestore, getAuth, getDexie, getFunctions, confirmationText, dialogResult, project, kickAllUsersFromProject, result, _message, message;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                getFirestore = _ref40.getFirestore, getAuth = _ref40.getAuth, getDexie = _ref40.getDexie, getFunctions = _ref40.getFunctions;
                confirmationText = 'This will remove all other users from the project, and make it available only to yourself, are you sure you want to continue?';
                _context12.next = 4;
                return postConfirmationDialog(dispatch, getState(), confirmationText, 'Make project Personal', 'Continue', 'Cancel');

              case 4:
                dialogResult = _context12.sent;

                if (!(dialogResult.result === 'affirmative')) {
                  _context12.next = 41;
                  break;
                }

                // Extract project from State before you unsubscribe from Database.
                project = extractProject(getState, projectId);
                dispatch(setIsShareMenuWaiting(true));
                dispatch(setShareMenuMessage("Migrating project."));
                dispatch(setShowCompletedTasksAsync(false));
                dispatch(selectProject(-1));
                _context12.prev = 11;
                kickAllUsersFromProject = getFunctions().httpsCallable('kickAllUsersFromProject');
                _context12.next = 15;
                return kickAllUsersFromProject({
                  projectId: projectId
                });

              case 15:
                result = _context12.sent;

                if (!(result.data.status === 'complete')) {
                  _context12.next = 32;
                  break;
                }

                dispatch(unsubscribeFromDatabaseAsync());
                _context12.prev = 18;
                _context12.next = 21;
                return moveProjectToLocalLocationAsync(getState, getFirestore, projectId, project);

              case 21:
                dispatch(subscribeToDatabaseAsync());
                dispatch(setIsShareMenuWaiting(false));
                dispatch(setShareMenuMessage(""));
                _context12.next = 32;
                break;

              case 26:
                _context12.prev = 26;
                _context12.t0 = _context12["catch"](18);
                _message = 'An error occured whilst migrating project';
                postGeneralSnackbar(dispatch, getState(), 'error', _message, 0, 'Dismiss');
                dispatch(setIsShareMenuWaiting(false));
                dispatch(setShareMenuMessage(""));

              case 32:
                if (result.data.status === 'error') {
                  postGeneralSnackbar(dispatch, getState(), 'error', result.data.message, 0, 'Dismiss');
                  dispatch(setIsShareMenuWaiting(false));
                  dispatch(setShareMenuMessage(""));
                }

                _context12.next = 41;
                break;

              case 35:
                _context12.prev = 35;
                _context12.t1 = _context12["catch"](11);
                message = "An Error occured, are you sure you are connected to the internet? Error Message : ".concat(_context12.t1.message);
                postGeneralSnackbar(dispatch, getState(), 'error', message, 0, 'Dismiss');
                dispatch(setIsShareMenuWaiting(false));
                dispatch(setShareMenuMessage(""));

              case 41:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[11, 35], [18, 26]]);
      }));

      return function (_x34, _x35, _x36) {
        return _ref41.apply(this, arguments);
      };
    }()
  );
}

function moveProjectToLocalLocationAsync(getState, getFirestore, projectId, currentProject) {
  return new Promise(function (resolve, reject) {
    // Transfer Project to Local Location.
    var remoteRef = getFirestore().collection(_paths.REMOTES).doc(projectId);
    var targetBatch = new _firestoreBatchPaginator["default"](getFirestore());
    var sourceBatch = new _firestoreBatchPaginator["default"](getFirestore());
    var requests = []; // Top Level Project Data.

    var project = (0, _pounderStores.ProjectFactory)(currentProject.projectName, projectId, false, currentProject.created, currentProject.updated); // Project

    var topLevelUserRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTS).doc(projectId);
    targetBatch.set(topLevelUserRef, project);
    var topLevelRemoteRef = getFirestore().collection(_paths.REMOTES).doc(projectId);
    sourceBatch["delete"](topLevelRemoteRef); // Project Layout

    requests.push(remoteRef.collection(_paths.PROJECTLAYOUTS).doc(projectId).get().then(function (layoutDoc) {
      if (layoutDoc.exists) {
        var ref = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTLAYOUTS).doc(layoutDoc.id);
        targetBatch.set(ref, layoutDoc.data());
        sourceBatch["delete"](layoutDoc.ref);
      }
    })); // Task Lists.

    requests.push(remoteRef.collection(_paths.TASKLISTS).where('project', '==', projectId).get().then(function (taskListsSnapshot) {
      taskListsSnapshot.forEach(function (taskListDoc) {
        var ref = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc(taskListDoc.id);
        targetBatch.set(ref, taskListDoc.data());
        sourceBatch["delete"](taskListDoc.ref);
      });
    })); // Tasks

    requests.push(new Promise(function (resolve, reject) {
      remoteRef.collection(_paths.TASKS).where('project', '==', projectId).get().then(function (tasksSnapshot) {
        var taskCommentRequests = [];
        tasksSnapshot.forEach(function (taskDoc) {
          var targetTaskRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS).doc(taskDoc.id);
          targetBatch.set(targetTaskRef, taskDoc.data());
          sourceBatch["delete"](taskDoc.ref); // Task may have Comments. Query for Comments and add to targetBatch.

          if (taskDoc.data().mightHaveTaskComments === true) {
            taskCommentRequests.push(taskDoc.ref.collection(_paths.TASKCOMMENTS).get().then(function (commentsSnapshot) {
              commentsSnapshot.forEach(function (commentDoc) {
                targetBatch.set(targetTaskRef.collection(_paths.TASKCOMMENTS).doc(commentDoc.id), commentDoc.data());
              });
            }));
          }
        }); // Don't resolve until all Requests to get Comments have been completed.

        Promise.all(taskCommentRequests).then(function () {
          resolve();
        })["catch"](function (error) {
          reject(error);
        });
      });
    })); // Remote Id would have been taken care of by kickAllUsersFromProject Server function.

    Promise.all(requests).then(function () {
      targetBatch.commit().then(function () {
        sourceBatch.commit().then(function () {
          resolve();
        })["catch"](function (error) {
          reject(error);
        });
      })["catch"](function (error) {
        reject(error);
      });
    });
  });
}

function inviteUserToProjectAsync(targetEmail, projectId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref43 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee13(dispatch, getState, _ref42) {
        var getFirestore, getAuth, getDexie, getFunctions, projectName, sourceDisplayName, sourceEmail, role, slowMessageTimer, getRemoteUserData, result, userData, inviteData, sendProjectInvite, message;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                getFirestore = _ref42.getFirestore, getAuth = _ref42.getAuth, getDexie = _ref42.getDexie, getFunctions = _ref42.getFunctions;
                projectName = getState().projects.find(function (item) {
                  return item.uid === projectId;
                }).projectName;
                sourceDisplayName = getState().displayName;
                sourceEmail = getState().userEmail;
                role = 'member';
                dispatch(setIsShareMenuWaiting(true));
                dispatch(setShareMenuMessage('Searching for User...'));
                slowMessageTimer = setTimeout(function () {
                  var message = "Hang tight!\n The servers are waking up.";
                  dispatch(setShareMenuSubMessage(message));
                }, 5000);
                getRemoteUserData = getFunctions().httpsCallable('getRemoteUserData');
                _context13.prev = 9;
                _context13.next = 12;
                return getRemoteUserData({
                  targetEmail: targetEmail
                });

              case 12:
                result = _context13.sent;

                if (!(result.data.status === 'user found')) {
                  _context13.next = 23;
                  break;
                }

                // User Found.
                userData = result.data.userData;
                inviteData = {
                  projectName: projectName,
                  sourceEmail: sourceEmail,
                  sourceDisplayName: sourceDisplayName,
                  targetDisplayName: userData.displayName,
                  targetEmail: userData.email,
                  projectId: projectId,
                  targetUserId: userData.userId,
                  sourceUserId: (0, _pounderFirebase.getUserUid)(),
                  role: role // If the project isn't Remote already it needs to be Moved. Promise will resolve Imediately if no migration
                  // is required, otherwise it will resolve when migration is complete.

                };
                _context13.next = 18;
                return maybeMigrateProjectAsync(dispatch, getFirestore, getState, projectId);

              case 18:
                dispatch(setShareMenuMessage('Sending invite.'));
                sendProjectInvite = getFunctions().httpsCallable('sendProjectInvite');
                sendProjectInvite(inviteData).then(function (result) {
                  if (result.data.status === 'complete') {
                    postGeneralSnackbar(dispatch, getState(), 'information', "Invite sent", 4000, '');
                    dispatch(setIsShareMenuWaiting(false));
                    dispatch(setShareMenuMessage(""));
                    dispatch(setShareMenuSubMessage(""));
                    dispatch(selectProject(projectId));
                    clearTimeout(slowMessageTimer);
                  } else {
                    postGeneralSnackbar(dispatch, getState(), 'error', result.data.error, 4000, '');
                    dispatch(setIsShareMenuWaiting(false));
                    dispatch(setShareMenuMessage(""));
                    dispatch(setShareMenuSubMessage(""));
                    clearTimeout(slowMessageTimer);
                  }
                });
                _context13.next = 28;
                break;

              case 23:
                // User not Found.
                postGeneralSnackbar(dispatch, getState(), 'information', 'User not found', 4000, '');
                dispatch(setIsShareMenuWaiting(false));
                dispatch(setShareMenuMessage(""));
                dispatch(setShareMenuSubMessage(""));
                clearTimeout(slowMessageTimer);

              case 28:
                _context13.next = 38;
                break;

              case 30:
                _context13.prev = 30;
                _context13.t0 = _context13["catch"](9);
                dispatch(setIsShareMenuWaiting(false));
                dispatch(setShareMenuMessage(''));
                dispatch(setShareMenuSubMessage(''));
                message = "An Error occured, are you sure you are connected to the internet? Error Message : ".concat(_context13.t0.message);
                postGeneralSnackbar(dispatch, getState(), 'error', message, 0, 'Dismiss');
                clearTimeout(slowMessageTimer);

              case 38:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[9, 30]]);
      }));

      return function (_x37, _x38, _x39) {
        return _ref43.apply(this, arguments);
      };
    }()
  );
}

function undoLastActionAsync() {
  return function (dispatch, getState, _ref44) {
    var getFirestore = _ref44.getFirestore,
        getAuth = _ref44.getAuth,
        getDexie = _ref44.getDexie,
        getFunctions = _ref44.getFunctions;
    undoAsync(dispatch, getState, getFirestore, getDexie);
  };
}

function updateMemberRoleAsync(userId, projectId, newRole) {
  return (
    /*#__PURE__*/
    function () {
      var _ref46 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee14(dispatch, getState, _ref45) {
        var getFirestore, getAuth, getDexie, getFunctions, _message2, dialogResult, memberRef;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                getFirestore = _ref45.getFirestore, getAuth = _ref45.getAuth, getDexie = _ref45.getDexie, getFunctions = _ref45.getFunctions;

                if (!(userId === (0, _pounderFirebase.getUserUid)())) {
                  _context14.next = 8;
                  break;
                }

                _message2 = 'If you demote yourself, you will need to be promoted by another owner. Are you sure you want to continue?';
                _context14.next = 5;
                return postConfirmationDialog(dispatch, getState(), _message2, 'Demote yourself', 'Continue', 'Cancel');

              case 5:
                dialogResult = _context14.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context14.next = 8;
                  break;
                }

                return _context14.abrupt("return");

              case 8:
                addUpdatingUserId(dispatch, getState, userId, projectId);
                _context14.prev = 9;
                memberRef = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.MEMBERS).doc(userId);
                _context14.next = 13;
                return memberRef.update({
                  role: newRole
                });

              case 13:
                removeUpdatingUserId(dispatch, getState, userId, projectId);
                _context14.next = 20;
                break;

              case 16:
                _context14.prev = 16;
                _context14.t0 = _context14["catch"](9);
                handleFirebaseUpdateError(_context14.t0, getState(), dispatch);
                removeUpdatingUserId(dispatch, getState, userId, projectId);

              case 20:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[9, 16]]);
      }));

      return function (_x40, _x41, _x42) {
        return _ref46.apply(this, arguments);
      };
    }()
  );
}

function leaveRemoteProjectAsync(projectId, userId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref48 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee15(dispatch, getState, _ref47) {
        var getFirestore, getAuth, getDexie, getFunctions, projectName, dialogResult, kickUserFromProject, message;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                getFirestore = _ref47.getFirestore, getAuth = _ref47.getAuth, getDexie = _ref47.getDexie, getFunctions = _ref47.getFunctions;
                projectName = getProjectName(getState().projects, projectId);
                _context15.next = 4;
                return postConfirmationDialog(dispatch, getState(), "Are you sure you want to leave ".concat(projectName, "?"), 'Leave project', 'Leave', 'Cancel');

              case 4:
                dialogResult = _context15.sent;

                if (!(dialogResult.result === 'affirmative')) {
                  _context15.next = 20;
                  break;
                }

                _context15.prev = 6;
                kickUserFromProject = getFunctions().httpsCallable('kickUserFromProject');
                _context15.next = 10;
                return kickUserFromProject({
                  userId: userId,
                  projectId: projectId
                });

              case 10:
                dispatch(selectProject(-1));
                dispatch(closeShareMenu());
                dispatch(setIsAppDrawerOpen(true));
                postGeneralSnackbar(dispatch, getState(), 'information', 'Left Project', 4000, '');
                _context15.next = 20;
                break;

              case 16:
                _context15.prev = 16;
                _context15.t0 = _context15["catch"](6);
                message = "Something went wrong when leaving project: " + _context15.t0.message;
                postGeneralSnackbar(dispatch, getState(), 'error', message, 0, 'Dismiss');

              case 20:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[6, 16]]);
      }));

      return function (_x43, _x44, _x45) {
        return _ref48.apply(this, arguments);
      };
    }()
  );
}

function kickUserFromProjectAsync(projectId, userId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref50 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee16(dispatch, getState, _ref49) {
        var getFirestore, getAuth, getDexie, getFunctions, displayName, projectName, dialogResult, kickUserFromProject, message;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                getFirestore = _ref49.getFirestore, getAuth = _ref49.getAuth, getDexie = _ref49.getDexie, getFunctions = _ref49.getFunctions;
                displayName = (0, _pounderUtilities.GetDisplayNameFromLookup)(userId, getState().memberLookup);
                projectName = getProjectName(getState().projects, projectId);
                _context16.next = 5;
                return postConfirmationDialog(dispatch, getState(), "Are you sure you want to remove ".concat(displayName, " from ").concat(projectName, "?"), 'Remove user', 'Remove', 'Cancel');

              case 5:
                dialogResult = _context16.sent;

                if (!(dialogResult.result === 'affirmative')) {
                  _context16.next = 21;
                  break;
                }

                addUpdatingUserId(dispatch, getState, userId, projectId);
                _context16.prev = 8;
                kickUserFromProject = getFunctions().httpsCallable('kickUserFromProject');
                _context16.next = 12;
                return kickUserFromProject({
                  userId: userId,
                  projectId: projectId
                });

              case 12:
                removeUpdatingUserId(dispatch, getState, userId, projectId);
                postGeneralSnackbar(dispatch, getState(), 'information', 'User kicked', 4000, '');
                _context16.next = 21;
                break;

              case 16:
                _context16.prev = 16;
                _context16.t0 = _context16["catch"](8);
                message = "Something went wrong when kicking a user: " + _context16.t0.message;
                postGeneralSnackbar(dispatch, getState(), 'error', message, 0, 'Dismiss');
                removeUpdatingUserId(dispatch, getState, userId, projectId);

              case 21:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[8, 16]]);
      }));

      return function (_x46, _x47, _x48) {
        return _ref50.apply(this, arguments);
      };
    }()
  );
}

function maybeMigrateProjectAsync(dispatch, getFirestore, getState, projectId) {
  // Maybe migrate the project first if requried. Saves you copying the code into two branches of an if else.
  // If project is already remote, promise will resolve imediately and allow further execution to continue, otherwise it will
  // hold.. This is maybe a good candidate for await/async.
  return new Promise(function (resolve, reject) {
    if (!isProjectRemote(getState, projectId)) {
      // Migrate project to 'remotes' collection.
      // Extract the project before you unsubscribe from the Database.
      var project = extractProject(getState, projectId);
      dispatch(setShowCompletedTasksAsync(false));
      dispatch(selectProject(-1));
      dispatch(clearData()); // Stops RGL seeing duplicate Task Lists.

      dispatch(setShareMenuMessage('Migrating Project...'));
      dispatch(unsubscribeFromDatabaseAsync(projectId));
      moveProjectToRemoteLocationAsync(getFirestore, getState, projectId, project).then(function () {
        dispatch(subscribeToDatabaseAsync());
        dispatch(selectProject(projectId));
        resolve();
      })["catch"](function (error) {
        postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + error.message, 0, 'Dismiss');
        reject();
      });
    } else {
      resolve();
    }
  });
}

function moveProjectToRemoteLocationAsync(getFirestore, getState, projectId, currentProject) {
  return new Promise(function (resolve, reject) {
    // Transfer Project.
    var userRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)());
    var targetBatch = new _firestoreBatchPaginator["default"](getFirestore());
    var sourceBatch = new _firestoreBatchPaginator["default"](getFirestore());
    var requests = [];
    var topLevelData = (0, _pounderStores.ProjectFactory)(currentProject.projectName, projectId, true, currentProject.created, currentProject.updated);
    var topLevelRef = getFirestore().collection(_paths.REMOTES).doc(projectId);
    targetBatch.set(topLevelRef, topLevelData);
    sourceBatch["delete"](getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTS).doc(projectId)); // Members.

    var newMember = new _pounderStores.MemberStore((0, _pounderFirebase.getUserUid)(), projectId, getState().displayName, getState().userEmail, 'added', 'owner');
    var memberRef = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.MEMBERS).doc(newMember.userId);
    targetBatch.set(memberRef, Object.assign({}, newMember)); // Project Layout

    requests.push(userRef.collection(_paths.PROJECTLAYOUTS).doc(projectId).get().then(function (layoutDoc) {
      if (layoutDoc.exists) {
        var ref = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.PROJECTLAYOUTS).doc(layoutDoc.id);
        targetBatch.set(ref, layoutDoc.data());
        sourceBatch["delete"](layoutDoc.ref);
      }
    })); // Task Lists.

    requests.push(userRef.collection(_paths.TASKLISTS).where('project', '==', projectId).get().then(function (taskListsSnapshot) {
      taskListsSnapshot.forEach(function (taskListDoc) {
        var ref = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKLISTS).doc(taskListDoc.id);
        targetBatch.set(ref, taskListDoc.data());
        sourceBatch["delete"](taskListDoc.ref);
      });
    })); // Tasks.
    // Query and Collect Tasks, if Task has Comments, Query and collect them as well.

    requests.push(new Promise(function (resolve, reject) {
      userRef.collection(_paths.TASKS).where('project', '==', projectId).get().then(function (tasksSnapshot) {
        var taskCommentRequests = [];
        tasksSnapshot.forEach(function (taskDoc) {
          var targetTaskRef = getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.TASKS).doc(taskDoc.id);
          targetBatch.set(targetTaskRef, taskDoc.data());
          sourceBatch["delete"](taskDoc.ref); // Task may have Comments. Query for Comments and add to targetBatch.

          if (taskDoc.data().mightHaveTaskComments === true) {
            taskCommentRequests.push(taskDoc.ref.collection(_paths.TASKCOMMENTS).get().then(function (commentsSnapshot) {
              commentsSnapshot.forEach(function (commentDoc) {
                targetBatch.set(targetTaskRef.collection(_paths.TASKCOMMENTS).doc(commentDoc.id), commentDoc.data());
              });
            }));
          }
        }); // Don't resolve until all Requests to get Comments have been completed.

        Promise.all(taskCommentRequests).then(function () {
          resolve();
        })["catch"](function (error) {
          reject(error);
        });
      });
    })); // Place RemoteId.

    var remoteIdRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.REMOTE_IDS).doc(projectId);
    sourceBatch.set(remoteIdRef, {
      projectId: projectId
    });
    Promise.all(requests).then(function () {
      targetBatch.commit().then(function () {
        sourceBatch.commit().then(function () {
          resolve();
        })["catch"](function (error) {
          reject('Error while removing local references: ' + error.message);
        });
      })["catch"](function (error) {
        reject('Error while moving Local Project: ' + error.message);
      });
    });
  });
}

function attachAuthListenerAsync() {
  return function (dispatch, getState, _ref51) {
    var getFirestore = _ref51.getFirestore,
        getAuth = _ref51.getAuth,
        getDexie = _ref51.getDexie,
        getFunctions = _ref51.getFunctions;
    getAuth().onAuthStateChanged(
    /*#__PURE__*/
    function () {
      var _ref52 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee17(user) {
        var ref;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!user) {
                  _context17.next = 23;
                  break;
                }

                if (!(newUser !== null)) {
                  _context17.next = 13;
                  break;
                }

                // A new user has just registered.
                clearFirstTimeBootFlag(dispatch, getState); // // Send them to the Welcome Page if on Desktop.
                // if (HANDBALL_DEVICE === 'desktop') {
                //     dispatch(setIsAppSettingsOpen(true));
                //     dispatch(setAppSettingsMenuPage('welcome'));
                // }
                //  Make a directory listing for them.

                ref = getFirestore().collection(_paths.DIRECTORY).doc(newUser.email);
                _context17.prev = 4;
                _context17.next = 7;
                return ref.set(Object.assign({}, new _pounderStores.DirectoryStore(newUser.email, newUser.displayName, user.uid)));

              case 7:
                newUser = null;
                _context17.next = 13;
                break;

              case 10:
                _context17.prev = 10;
                _context17.t0 = _context17["catch"](4);
                postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + _context17.t0.message, 0, 'Dismiss');

              case 13:
                if (getState().generalConfig.isFirstTimeBoot) {
                  clearFirstTimeBootFlag(dispatch, getState);
                }

                if (getState().isOnboarding) {
                  dispatch(setIsOnboarding(false));
                } // User is Logged in.


                (0, _pounderFirebase.setUserUid)(user.uid);
                dispatch(subscribeToDatabaseAsync());
                dispatch(setIsLoggedInFlag(true));
                dispatch(setUserEmail(user.email));
                dispatch(setDisplayName(user.displayName));
                dispatch(setAuthStatusMessage("Logged in"));
                _context17.next = 24;
                break;

              case 23:
                // User is logged out.
                // This Code may be called when App is booting up. If getUserUid is an empty string, then the App is booting
                // and no action is required.
                if ((0, _pounderFirebase.getUserUid)() !== "") {
                  dispatch(setAuthStatusMessage("Logged out")); //dispatch(unsubscribeFromDatabaseAsync());

                  dispatch(setIsLoggedInFlag(false));
                  dispatch(setUserEmail(""));
                  dispatch(setDisplayName(""));
                  dispatch(selectProject(-1));
                  dispatch(clearData());
                  (0, _pounderFirebase.setUserUid)(""); // Clear UserUid Last as actions above may require it to build valid Database References.
                }

              case 24:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[4, 10]]);
      }));

      return function (_x49) {
        return _ref52.apply(this, arguments);
      };
    }());
  };
}

function subscribeToDatabaseAsync() {
  return function (dispatch, getState, _ref53) {
    var getFirestore = _ref53.getFirestore,
        getAuth = _ref53.getAuth,
        getDexie = _ref53.getDexie,
        getFunctions = _ref53.getFunctions;
    // Get Projects (Also attaches a Value listener for future changes).
    dispatch(getProjectsAsync()); // Local Project Layouts.

    dispatch(getLocalProjectLayoutsAsync()); // Remote Projects (Also attaches a Value listener for future changes).

    dispatch(getRemoteProjectIdsAsync()); // Get Task Lists (Also Attaches a value listener for future changes).

    dispatch(getTaskListsAsync()); // Get Tasks (Also attaches a Value listener for future changes).

    dispatch(getIncompletedLocalTasksAsync());

    if (getState().showCompletedTasks) {
      dispatch(getCompletedLocalTasksAsync());
    } // Get Account Config (Also attaches a Value listener for future changes).


    dispatch(getAccountConfigAsync()); // Project Invites (Also attaches a Value listener for future changes).

    dispatch(getInvitesAsync());
  };
}

function getInvitesAsync() {
  return function (dispatch, getState, _ref54) {
    var getFirestore = _ref54.getFirestore,
        getAuth = _ref54.getAuth,
        getDexie = _ref54.getDexie,
        getFunctions = _ref54.getFunctions;
    invitesUnsubscribe = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.INVITES).onSnapshot(function (snapshot) {
      if (snapshot.docChanges().length > 0) {
        var invites = [];
        snapshot.forEach(function (doc) {
          invites.push(doc.data());
        });
        dispatch(receiveInvites(invites));
      }
    });
  };
}

function unsubscribeFromDatabaseAsync() {
  return function (dispatch, getState, _ref55) {
    var getFirestore = _ref55.getFirestore,
        getAuth = _ref55.getAuth,
        getDexie = _ref55.getDexie,
        getFunctions = _ref55.getFunctions;
    dispatch(unsubscribeProjectsAsync());
    getState().remoteProjectIds.forEach(function (id) {
      dispatch(unsubscribeFromRemoteProjectAsync(id));
    });
    dispatch(unsubscribeRemoteIds());
    dispatch(unsubscribeTaskListsAsync());
    dispatch(unsubscribeTasksAsync());
    dispatch(unsubscribeProjectLayoutsAsync());
    dispatch(unsubscribeAccountConfigAsync());
    dispatch(unsubscribeInvitesAsync()); // Clear last Undo Action.

    getDexie().lastUndoAction["delete"]('0');
    dispatch(setLastUndoAction(null));
  };
}

function unsubscribeRemoteIds() {
  return function (dispatch, getState, _ref56) {
    var getFirestore = _ref56.getFirestore,
        getAuth = _ref56.getAuth,
        getDexie = _ref56.getDexie,
        getFunctions = _ref56.getFunctions;

    if (remoteProjectIdsUnsubscribe !== null) {
      remoteProjectIdsUnsubscribe();
    }
  };
}

function logOutUserAsync() {
  return function (dispatch, getState, _ref57) {
    var getFirestore = _ref57.getFirestore,
        getAuth = _ref57.getAuth,
        getDexie = _ref57.getDexie,
        getFunctions = _ref57.getFunctions;
    dispatch(unsubscribeFromDatabaseAsync());
    getAuth().signOut().then(function () {})["catch"](function (error) {
      var message = handleAuthError(error);
      postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + error.message, 0, 'Dismiss');
    });
  };
}

function logInUserAsync(email, password) {
  return function (dispatch, getState, _ref58) {
    var getFirestore = _ref58.getFirestore,
        getAuth = _ref58.getAuth,
        getDexie = _ref58.getDexie,
        getFunctions = _ref58.getFunctions;
    dispatch(setIsLoggingInFlag(true));
    dispatch(setAuthStatusMessage("Logging in"));
    var parsedEmail = email.toLowerCase().trim(); // Set Persistence.

    getAuth().setPersistence('local').then(function () {
      getAuth().signInWithEmailAndPassword(parsedEmail, password)["catch"](function (error) {
        handleAuthError(dispatch, getState(), error);
        dispatch(setIsLoggingInFlag(false));
        dispatch(setAuthStatusMessage("Logged out"));
      });
    })["catch"](function (error) {
      handleAuthError(dispatch, getState(), error);
      dispatch(setIsLoggingInFlag(false));
      dispatch(setAuthStatusMessage("Logged Out"));
    });
  };
}

function setFavouriteProjectIdAsync(projectId) {
  return function (dispatch, getState, _ref59) {
    var getFirestore = _ref59.getFirestore,
        getAuth = _ref59.getAuth,
        getDexie = _ref59.getDexie,
        getFunctions = _ref59.getFunctions;
    var ref = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.ACCOUNT).doc(_paths.ACCOUNT_DOC_ID);
    ref.set({
      favouriteProjectId: projectId
    }).then(function () {// Carefull what you do here, promises don't resolve if you are offline.
    })["catch"](function (error) {
      handleFirebaseUpdateError(error, getState(), dispatch);
    });
  };
}

function getGeneralConfigAsync() {
  return function (dispatch, getState, _ref60) {
    var getFirestore = _ref60.getFirestore,
        getAuth = _ref60.getAuth,
        getDexie = _ref60.getDexie,
        getFunctions = _ref60.getFunctions;
    getDexie().generalConfig.where('id').equals(0).first().then(function (data) {
      if (data !== undefined) {
        var config = data.value;
        dispatch(receiveGeneralConfig(config));

        if (getState().isStartingUp) {
          // Application is Starting up. Dispatch Actions to Sync appliction to Config State.
          syncAppToConfig(config, dispatch);
        }
      } // If data doesn't exist in Dexie we can safely assume that the Fallback values given to the initial state
      // are still correct.


      if (getState().isStartingUp) {
        syncAppToConfig(getState().generalConfig, dispatch);
      }
    });
  };
}

function getCSSConfigAsync() {
  return function (dispatch, getState, _ref61) {
    var getFirestore = _ref61.getFirestore,
        getAuth = _ref61.getAuth,
        getDexie = _ref61.getDexie,
        getFunctions = _ref61.getFunctions;
    getDexie().cssConfig.where('id').equals(0).first().then(function (data) {
      if (data !== undefined) {
        // User has modified values.
        // Combine current State with values returned from Dexie.
        var configFromDB = data.value;
        var existingConfig = getState().cssConfig;

        var newConfig = _objectSpread({}, existingConfig);

        for (var propertyName in configFromDB) {
          newConfig[propertyName] = configFromDB[propertyName];
        }

        dispatch(receiveCSSConfig(newConfig));
      } // Nothing returned from Dexie. This means the user hasn't modified any values so we can rely on the
      // default values provided to the initial state.

    });
  };
}

function setAllColorsToDefaultAsync() {
  return function (dispatch, getState, _ref62) {
    var getFirestore = _ref62.getFirestore,
        getAuth = _ref62.getAuth,
        getDexie = _ref62.getDexie,
        getFunctions = _ref62.getFunctions;
    // Update Dexie.
    getDexie().cssConfig.put({
      id: 0,
      value: _pounderStores.CssConfigStore
    }).then(function () {}); // Update State.

    dispatch(receiveCSSConfig(_pounderStores.CssConfigStore));
  };
}

function setCSSConfigAsync(newConfig) {
  return function (dispatch, getState, _ref63) {
    var getFirestore = _ref63.getFirestore,
        getAuth = _ref63.getAuth,
        getDexie = _ref63.getDexie,
        getFunctions = _ref63.getFunctions;
    // Update Dexie.
    getDexie().cssConfig.put({
      id: 0,
      value: newConfig
    }).then(function () {}); // Update State.

    dispatch(receiveCSSConfig(newConfig));
  };
}

function setGeneralConfigAsync(newConfig) {
  return function (dispatch, getState, _ref64) {
    var getFirestore = _ref64.getFirestore,
        getAuth = _ref64.getAuth,
        getDexie = _ref64.getDexie,
        getFunctions = _ref64.getFunctions;
    getDexie().generalConfig.put({
      id: 0,
      value: newConfig
    }).then(function () {}); // Update State.

    dispatch(receiveGeneralConfig(newConfig));
  };
}

function purgeCompleteTasksAsync() {
  return function (dispatch, getState, _ref65) {
    var getFirestore = _ref65.getFirestore,
        getAuth = _ref65.getAuth,
        getDexie = _ref65.getDexie,
        getFunctions = _ref65.getFunctions;
    dispatch(setDatabasePurgingFlag(true));
    getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS).get().then(function (snapshot) {
      // Collect Id's of completed Tasks.
      var completedTaskIds = [];
      snapshot.forEach(function (doc) {
        if (doc.data().isComplete) {
          completedTaskIds.push(doc.id);
        }
      }); // Delete those Tasks.
      // Build Batch.

      var batch = new _firestoreBatchPaginator["default"](getFirestore());
      completedTaskIds.forEach(function (taskId) {
        batch["delete"](getFirestore().collection(_paths.TASKS).doc(taskId));
      }); // Execute Batch.

      batch.commit().then(function () {
        dispatch(setDatabasePurgingFlag(false));
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      });
    });
  };
}

function getDatabaseInfoAsync() {
  return function (dispatch, getState, _ref66) {
    var getFirestore = _ref66.getFirestore,
        getAuth = _ref66.getAuth,
        getDexie = _ref66.getDexie,
        getFunctions = _ref66.getFunctions;
    dispatch(setDatabaseInfo("...Collecting Info"));
    var projectCount = getState().projects.length;
    var taskListCount = getState().taskLists.length;
    var tasksCount = getState().tasks.length;
    var completedTasksCount = getState().tasks.filter(function (item) {
      return item.isComplete === true;
    }).length; // Collect Precursor data for calculating Orphans.

    var projectIds = getState().projects.map(function (item) {
      return item.uid;
    });
    var taskListIds = getState().taskLists.map(function (item) {
      return item.uid;
    }); // Calculate Orphans
    // Tasks Orphaned from Project.

    var taskOrphansCount = getState().tasks.filter(function (item) {
      return !projectIds.includes(item.project);
    }).length; // TaskLists Orphaned from Project.

    var taskListOrphansCount = getState().taskLists.filter(function (item) {
      return !projectIds.includes(item.project);
    }); // Tasks Orphaned from TaskLists.

    var taskTaskListOrphansCount = getState().tasks.filter(function (item) {
      return !taskListIds.includes(item.taskList);
    }); // Build Info String.

    var infoString = "********** DATABASE INFO **********\n" + "                   ITEM COUNTS\n" + "-> Projects:  " + projectCount + "\n" + "-> Task Lists:    " + taskListCount + "\n" + "-> Tasks (Total):    " + tasksCount + "\n" + "-> Tasks (Completed):    " + completedTasksCount + "\n\n" + "                   ORPHAN ITEM COUNTS\n" + "Orphan Items are created from Database Sync issues, usually from a bad internet connection." + "\n" + "-> Tasks orphaned from Project:   " + taskOrphansCount + "\n" + "-> Tasks orphaned from Task Lists:    " + taskTaskListOrphansCount + "\n" + "-> Task Lists orphaned from Project:  " + taskListOrphansCount + "\n\n" + "\n \n " + "********** END OF INFO **********";
    dispatch(setDatabaseInfo(infoString));
  };
}

function updateTaskPriorityAsync(taskId, newValue, oldValue) {
  return function (dispatch, getState, _ref67) {
    var getFirestore = _ref67.getFirestore,
        getAuth = _ref67.getAuth,
        getDexie = _ref67.getDexie,
        getFunctions = _ref67.getFunctions;

    if (newValue !== oldValue) {
      // Determine Reference.
      var taskRef = getTaskRef(getFirestore, getState, taskId); // Update Firestore.

      taskRef.update({
        isHighPriority: newValue,
        metadata: getUpdatedMetadata(extractCurrentMetadata(getState(), taskId), {
          updatedBy: getState().displayName,
          updatedOn: getHumanFriendlyDate()
        })
      }).then(function () {// Careful what you do here, promises don't resolve if you are offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      }); // Project updated metadata.

      updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
    }
  };
}

function updateTaskDueDateAsync(taskId, newMoment, oldDate) {
  return function (dispatch, getState, _ref68) {
    var getFirestore = _ref68.getFirestore,
        getAuth = _ref68.getAuth,
        getDexie = _ref68.getDexie,
        getFunctions = _ref68.getFunctions;
    var newDate = newMoment === null ? "" : newMoment.toISOString();

    if (newDate !== oldDate) {
      // Update Firestore.
      var taskRef = getTaskRef(getFirestore, getState, taskId);
      taskRef.update({
        dueDate: newDate,
        isNewTask: false,
        metadata: getUpdatedMetadata(extractCurrentMetadata(getState(), taskId), {
          updatedBy: getState().displayName,
          updatedOn: getHumanFriendlyDate()
        })
      }).then(function () {// Carefull what you do here, promises don't resolve if you are offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      }); // Project updated metadata.

      updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
    }
  };
}

function updateChecklistSettingsAsync(taskListId, newValue) {
  return function (dispatch, getState, _ref69) {
    var getFirestore = _ref69.getFirestore,
        getAuth = _ref69.getAuth,
        getDexie = _ref69.getDexie,
        getFunctions = _ref69.getFunctions;
    var taskList = extractTaskList(taskListId, getState().taskLists);

    if (taskList === undefined) {
      return;
    }

    var existingSettings = _objectSpread({}, taskList.settings);

    existingSettings.checklistSettings = newValue;
    dispatch(updateTaskListSettingsAsync(taskListId, existingSettings));
  };
}

function updateTaskListSettingsAsync(taskListWidgetId, newValue) {
  return function (dispatch, getState, _ref70) {
    var getFirestore = _ref70.getFirestore,
        getAuth = _ref70.getAuth,
        getDexie = _ref70.getDexie,
        getFunctions = _ref70.getFunctions;
    // Update Firestore.
    var taskListRef = getTaskListRef(getFirestore, getState, taskListWidgetId);
    taskListRef.update({
      settings: Object.assign({}, newValue)
    }).then(function () {/// Carefull what you do here, promises don't resolve if you are offline.
    })["catch"](function (error) {
      handleFirebaseUpdateError(error, getState(), dispatch);
    });
  };
}

function removeTaskListAsync(taskListId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref72 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee18(dispatch, getState, _ref71) {
        var getFirestore, getAuth, getDexie, getFunctions, taskListName, dialogResult, taskListRef, selectedProjectId, relatedTaskRefs, batch, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ref;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                getFirestore = _ref71.getFirestore, getAuth = _ref71.getAuth, getDexie = _ref71.getDexie, getFunctions = _ref71.getFunctions;

                if (!(taskListId !== -1)) {
                  _context18.next = 43;
                  break;
                }

                taskListName = getTaskListName(getState().taskLists, taskListId);
                _context18.next = 5;
                return postConfirmationDialog(dispatch, getState(), "Are you sure you want to delete ".concat(taskListName, "?"), 'Delete List', "Delete", 'Cancel');

              case 5:
                dialogResult = _context18.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context18.next = 8;
                  break;
                }

                return _context18.abrupt("return");

              case 8:
                taskListRef = getTaskListRef(getFirestore, getState, taskListId);
                selectedProjectId = getState().selectedProjectId;
                relatedTaskRefs = collectTaskListRelatedTaskIds(getState().tasks, taskListId).map(function (id) {
                  return getTaskRef(getFirestore, getState, id);
                }); // Build Undo Action.

                pushUndoActionAsync(dispatch, getState, getFirestore, getDexie, {
                  type: 'taskListDelete',
                  refPath: taskListRef.path,
                  projectId: selectedProjectId,
                  relatedTaskRefPaths: relatedTaskRefs.map(function (item) {
                    return item.path;
                  }),
                  friendlyText: 'list delete'
                });
                dispatch(setFocusedTaskListId(-1)); // Project updated metadata.

                updateProjectUpdatedTime(getState, getFirestore, selectedProjectId);
                batch = getFirestore().batch();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context18.prev = 18;

                for (_iterator = relatedTaskRefs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  ref = _step.value;
                  batch.update(ref, {
                    isDeleted: true
                  });
                }

                _context18.next = 26;
                break;

              case 22:
                _context18.prev = 22;
                _context18.t0 = _context18["catch"](18);
                _didIteratorError = true;
                _iteratorError = _context18.t0;

              case 26:
                _context18.prev = 26;
                _context18.prev = 27;

                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }

              case 29:
                _context18.prev = 29;

                if (!_didIteratorError) {
                  _context18.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context18.finish(29);

              case 33:
                return _context18.finish(26);

              case 34:
                batch.update(taskListRef, {
                  isDeleted: true
                });
                _context18.prev = 35;
                _context18.next = 38;
                return batch.commit();

              case 38:
                _context18.next = 43;
                break;

              case 40:
                _context18.prev = 40;
                _context18.t1 = _context18["catch"](35);
                handleFirebaseUpdateError(_context18.t1, getState(), dispatch);

              case 43:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[18, 22, 26, 34], [27,, 29, 33], [35, 40]]);
      }));

      return function (_x50, _x51, _x52) {
        return _ref72.apply(this, arguments);
      };
    }()
  );
}

function updateProjectNameAsync(projectId, oldValue) {
  return (
    /*#__PURE__*/
    function () {
      var _ref74 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee19(dispatch, getState, _ref73) {
        var getFirestore, getAuth, getDexie, getFunctions, dialogResult, newValue, coercedValue, projectRef;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                getFirestore = _ref73.getFirestore, getAuth = _ref73.getAuth, getDexie = _ref73.getDexie, getFunctions = _ref73.getFunctions;
                _context19.next = 3;
                return postTextInputDialog(dispatch, getState(), 'Name', oldValue, 'Rename Project');

              case 3:
                dialogResult = _context19.sent;

                if (!(dialogResult.result === 'cancel')) {
                  _context19.next = 6;
                  break;
                }

                return _context19.abrupt("return");

              case 6:
                newValue = dialogResult.value;
                coercedValue = newValue === "" ? "Untitled Project" : newValue;

                if (!(coercedValue !== oldValue)) {
                  _context19.next = 19;
                  break;
                }

                _context19.prev = 9;
                projectRef = getProjectRef(getFirestore, getState, projectId);
                _context19.next = 13;
                return projectRef.update({
                  projectName: coercedValue
                });

              case 13:
                _context19.next = 18;
                break;

              case 15:
                _context19.prev = 15;
                _context19.t0 = _context19["catch"](9);
                handleFirebaseUpdateError(_context19.t0, getState(), dispatch);

              case 18:
                // Project updated metadata.
                updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);

              case 19:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, null, [[9, 15]]);
      }));

      return function (_x53, _x54, _x55) {
        return _ref74.apply(this, arguments);
      };
    }()
  );
}

function removeProjectAsync(projectId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref76 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee20(dispatch, getState, _ref75) {
        var getFirestore, getAuth, getDexie, getFunctions, projectName, dialogResult;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                getFirestore = _ref75.getFirestore, getAuth = _ref75.getAuth, getDexie = _ref75.getDexie, getFunctions = _ref75.getFunctions;

                if (!(projectId === -1)) {
                  _context20.next = 3;
                  break;
                }

                return _context20.abrupt("return");

              case 3:
                dispatch(setShowOnlySelfTasks(false));

                if (!(isProjectRemote(getState, projectId) === true)) {
                  _context20.next = 7;
                  break;
                }

                // Direct user to Share menu
                dispatch(openShareMenu(projectId));
                return _context20.abrupt("return");

              case 7:
                projectName = getProjectName(getState().projects, projectId);
                _context20.next = 10;
                return postConfirmationDialog(dispatch, getState(), "Are you sure you want to delete ".concat(projectName, "?"), 'Delete Project', "Delete", "Cancel");

              case 10:
                dialogResult = _context20.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context20.next = 13;
                  break;
                }

                return _context20.abrupt("return");

              case 13:
                dispatch(removeLocalProjectAsync(projectId));

              case 14:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x56, _x57, _x58) {
        return _ref76.apply(this, arguments);
      };
    }()
  );
}

function removeLocalProjectAsync(projectId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref78 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee21(dispatch, getState, _ref77) {
        var getFirestore, getAuth, getDexie, getFunctions, projectRef, projectLayoutRef, taskListRefs, taskRefs;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                getFirestore = _ref77.getFirestore, getAuth = _ref77.getAuth, getDexie = _ref77.getDexie, getFunctions = _ref77.getFunctions;

                if (!(projectId === -1)) {
                  _context21.next = 3;
                  break;
                }

                return _context21.abrupt("return");

              case 3:
                dispatch(setShowCompletedTasksAsync(false));
                dispatch(selectProject(-1));
                projectRef = getProjectRef(getFirestore, getState, projectId);
                projectLayoutRef = getProjectLayoutRef(getFirestore, getState, projectId).doc(projectId);
                taskListRefs = getProjectRelatedTaskListRefs(getState, getFirestore, projectId);
                taskRefs = getProjectRelatedTaskRefs(getState, getFirestore, projectId);
                pushUndoActionAsync(dispatch, getState, getFirestore, getDexie, {
                  type: 'localProjectDelete',
                  projectId: projectId,
                  projectRefPath: projectRef.path,
                  projectLayoutRefPath: projectLayoutRef.path,
                  taskListRefPaths: taskListRefs.map(function (item) {
                    return item.path;
                  }),
                  taskRefPaths: taskRefs.map(function (item) {
                    return item.path;
                  }),
                  friendlyText: 'project delete'
                });
                _context21.prev = 10;
                _context21.next = 13;
                return projectRef.update({
                  isDeleted: true
                });

              case 13:
                _context21.next = 18;
                break;

              case 15:
                _context21.prev = 15;
                _context21.t0 = _context21["catch"](10);
                handleFirebaseUpdateError(_context21.t0, getState(), dispatch);

              case 18:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, null, [[10, 15]]);
      }));

      return function (_x59, _x60, _x61) {
        return _ref78.apply(this, arguments);
      };
    }()
  );
}

function getProjectRelatedTaskRefs(getState, getFirestore, projectId) {
  var relatedTaskIds = getState().tasks.filter(function (item) {
    return item.project === projectId;
  }).map(function (item) {
    return item.uid;
  });
  return relatedTaskIds.map(function (id) {
    return getTaskRef(getFirestore, getState, id);
  });
}

function getProjectRelatedTaskListRefs(getState, getFirestore, projectId) {
  var relatedTaskListIds = getState().taskLists.filter(function (item) {
    return item.project === projectId;
  }).map(function (item) {
    return item.uid;
  });
  return relatedTaskListIds.map(function (id) {
    return getTaskListRef(getFirestore, getState, id);
  });
}

function deleteLocalProject(_x62, _x63, _x64, _x65, _x66, _x67, _x68, _x69) {
  return _deleteLocalProject.apply(this, arguments);
}

function _deleteLocalProject() {
  _deleteLocalProject = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee33(dispatch, getFirestore, getState, projectId, projectRef, projectLayoutRef, taskListRefs, taskRefs) {
    var batch, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, taskListRef, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, taskRef;

    return regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            // Build Updates.
            batch = new _firestoreBatchPaginator["default"](getFirestore()); // TaskLists.

            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context33.prev = 4;

            for (_iterator2 = taskListRefs[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              taskListRef = _step2.value;
              batch["delete"](taskListRef);
            } // Tasks


            _context33.next = 12;
            break;

          case 8:
            _context33.prev = 8;
            _context33.t0 = _context33["catch"](4);
            _didIteratorError2 = true;
            _iteratorError2 = _context33.t0;

          case 12:
            _context33.prev = 12;
            _context33.prev = 13;

            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }

          case 15:
            _context33.prev = 15;

            if (!_didIteratorError2) {
              _context33.next = 18;
              break;
            }

            throw _iteratorError2;

          case 18:
            return _context33.finish(15);

          case 19:
            return _context33.finish(12);

          case 20:
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context33.prev = 23;

            for (_iterator3 = taskRefs[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              taskRef = _step3.value;
              batch["delete"](taskRef);
            } // Project Layout


            _context33.next = 31;
            break;

          case 27:
            _context33.prev = 27;
            _context33.t1 = _context33["catch"](23);
            _didIteratorError3 = true;
            _iteratorError3 = _context33.t1;

          case 31:
            _context33.prev = 31;
            _context33.prev = 32;

            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }

          case 34:
            _context33.prev = 34;

            if (!_didIteratorError3) {
              _context33.next = 37;
              break;
            }

            throw _iteratorError3;

          case 37:
            return _context33.finish(34);

          case 38:
            return _context33.finish(31);

          case 39:
            batch["delete"](projectLayoutRef); // Project.

            batch["delete"](projectRef); // Execute the Batch.

            _context33.prev = 41;
            _context33.next = 44;
            return batch.commit();

          case 44:
            _context33.next = 49;
            break;

          case 46:
            _context33.prev = 46;
            _context33.t2 = _context33["catch"](41);
            handleFirebaseUpdateError(_context33.t2, getState(), dispatch);

          case 49:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, null, [[4, 8, 12, 20], [13,, 15, 19], [23, 27, 31, 39], [32,, 34, 38], [41, 46]]);
  }));
  return _deleteLocalProject.apply(this, arguments);
}

function removeRemoteProjectAsync(projectId, preCondition) {
  return (
    /*#__PURE__*/
    function () {
      var _ref80 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee22(dispatch, getState, _ref79) {
        var getFirestore, getAuth, getDexie, getFunctions, _projectName, _text, _title, projectName, title, text, affirmativeButtonText, negativeButtonText, dialogResult, removeRemoteProject, result, message;

        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                getFirestore = _ref79.getFirestore, getAuth = _ref79.getAuth, getDexie = _ref79.getDexie, getFunctions = _ref79.getFunctions;

                if (!(preCondition === false)) {
                  _context22.next = 7;
                  break;
                }

                _projectName = getProjectName(getState().projects, projectId);
                _text = "Before you delete ".concat(_projectName, " you must promote another member to owner status");
                _title = 'Hang on!';
                postInformationDialog(dispatch, getState(), _text, _title);
                return _context22.abrupt("return");

              case 7:
                // Post Confirmation Dialog.
                projectName = getProjectName(getState().projects, projectId);
                title = "Delete Project";
                text = "".concat(projectName, " will be deleted forever. This can not be undone. Are you really sure you want to continue?");
                affirmativeButtonText = "Delete";
                negativeButtonText = 'Cancel';
                _context22.next = 14;
                return postConfirmationDialog(dispatch, getState(), text, title, affirmativeButtonText, negativeButtonText);

              case 14:
                dialogResult = _context22.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context22.next = 17;
                  break;
                }

                return _context22.abrupt("return");

              case 17:
                if (!(projectId !== -1 && isProjectRemote(getState, projectId))) {
                  _context22.next = 39;
                  break;
                }

                dispatch(setIsShareMenuWaiting(true));
                dispatch(setShareMenuMessage("Deleting Project"));
                dispatch(setShowCompletedTasksAsync(false));
                dispatch(selectProject(-1));
                removeRemoteProject = getFunctions().httpsCallable('removeRemoteProject');
                _context22.prev = 23;
                _context22.next = 26;
                return removeRemoteProject({
                  projectId: projectId
                });

              case 26:
                result = _context22.sent;

                if (result.data.status === 'complete') {
                  dispatch(setIsShareMenuOpen(false));
                  dispatch(setIsShareMenuWaiting(false));
                  dispatch(setShareMenuMessage(""));
                }

                if (result.data.status === 'error') {
                  postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + result.data.message, 0, 'Dismiss');
                  dispatch(setIsShareMenuWaiting(false));
                  dispatch(setShareMenuMessage(""));
                }

                _context22.next = 37;
                break;

              case 31:
                _context22.prev = 31;
                _context22.t0 = _context22["catch"](23);
                message = "An Error occured, are you sure you are connected to the internet? Error Message : ".concat(_context22.t0.message);
                postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + message, 0, 'Dismiss');
                dispatch(setIsShareMenuWaiting(false));
                dispatch(setShareMenuMessage(""));

              case 37:
                _context22.next = 41;
                break;

              case 39:
                message = "No project selected or project is not a shared project.";
                postGeneralSnackbar(dispatch, getState(), 'error', 'An error occured: ' + error.message, 4000, '');

              case 41:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, null, [[23, 31]]);
      }));

      return function (_x70, _x71, _x72) {
        return _ref80.apply(this, arguments);
      };
    }()
  );
}

function addNewProjectAsync() {
  return (
    /*#__PURE__*/
    function () {
      var _ref82 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee23(dispatch, getState, _ref81) {
        var getFirestore, getAuth, getDexie, getFunctions, dialogResult, newProjectName, batch, newProjectRef, newProjectId, newProject, newLayoutRef, newProjectLayout, newTaskListRef, newTaskList;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                getFirestore = _ref81.getFirestore, getAuth = _ref81.getAuth, getDexie = _ref81.getDexie, getFunctions = _ref81.getFunctions;
                dispatch(setShowOnlySelfTasks(false));

                if (!(getState().isLoggedIn === true)) {
                  _context23.next = 24;
                  break;
                }

                _context23.next = 5;
                return postTextInputDialog(dispatch, getState(), "Name", "", "Add new Project");

              case 5:
                dialogResult = _context23.sent;

                if (!(dialogResult.result === 'cancel')) {
                  _context23.next = 8;
                  break;
                }

                return _context23.abrupt("return");

              case 8:
                // Update Firestore.    
                newProjectName = dialogResult.value === '' ? 'Untitled Project' : dialogResult.value;
                batch = getFirestore().batch(); // Project.

                newProjectRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTS).doc();
                newProjectId = newProjectRef.id;
                newProject = new _pounderStores.ProjectStore(newProjectName, newProjectId, false, new Date().toISOString(), "");
                batch.set(newProjectRef, Object.assign({}, newProject)); // Layout

                newLayoutRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTLAYOUTS).doc(newProjectId);
                newProjectLayout = new _pounderStores.ProjectLayoutStore([], newProjectId, newProjectId);
                batch.set(newLayoutRef, Object.assign({}, newProjectLayout)); // Add an initial task list.

                newTaskListRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc();
                newTaskList = new _pounderStores.TaskListStore('Assorted', newProjectId, newTaskListRef.id, newTaskListRef.id, Object.assign({}, new _pounderStores.TaskListSettingsStore(true, "date added", (0, _pounderStores.ChecklistSettingsFactory)(false, "", "", 1))));
                batch.set(newTaskListRef, _objectSpread({}, newTaskList)); // Selections.

                dispatch(selectProject(newProjectId));
                dispatch(setOpenProjectSelectorId(newProjectId));
                dispatch(setFocusedTaskListId(newTaskListRef.id)); // Execute Additions.

                batch.commit().then(function () {// Carefull what you do here, promises don't resolve if you are offline.
                })["catch"](function (error) {
                  handleFirebaseUpdateError(error, getState(), dispatch);
                });

              case 24:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      return function (_x73, _x74, _x75) {
        return _ref82.apply(this, arguments);
      };
    }()
  );
}

function updateTaskCompleteAsync(taskId, newValue, oldValue, currentMetadata) {
  return (
    /*#__PURE__*/
    function () {
      var _ref84 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee24(dispatch, getState, _ref83) {
        var getFirestore, getAuth, getDexie, getFunctions, taskRef, completedBy, completedOn;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                getFirestore = _ref83.getFirestore, getAuth = _ref83.getAuth, getDexie = _ref83.getDexie, getFunctions = _ref83.getFunctions;

                if (oldValue !== newValue) {
                  // Update Firestore.
                  taskRef = getTaskRef(getFirestore, getState, taskId);
                  completedBy = newValue === true ? getState().displayName : "";
                  completedOn = newValue === true ? getHumanFriendlyDate() : "";
                  taskRef.update({
                    isComplete: newValue,
                    isNewTask: false,
                    metadata: getUpdatedMetadata(currentMetadata, {
                      completedBy: completedBy,
                      completedOn: completedOn
                    })
                  }).then(function () {// Carefull what you do here, promises don't resolve if you are offline.
                  })["catch"](function (error) {
                    handleFirebaseUpdateError(error, getState(), dispatch);
                  }); // Project updated metadata.

                  updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
                }

              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      return function (_x76, _x77, _x78) {
        return _ref84.apply(this, arguments);
      };
    }()
  );
}

function updateProjectLayoutAsync(layouts, oldLayouts, projectId) {
  return function (dispatch, getState, _ref85) {
    var getFirestore = _ref85.getFirestore,
        getAuth = _ref85.getAuth,
        getDexie = _ref85.getDexie,
        getFunctions = _ref85.getFunctions;
    var newTrimmedLayouts = sanitizeLayouts(layouts);
    var oldTrimmedLayouts = sanitizeLayouts(oldLayouts);

    if (compareProjectLayouts(oldTrimmedLayouts, newTrimmedLayouts) !== true) {
      // Update Firestore.
      var batch = getFirestore().batch();
      var targetProjectLayoutId = (0, _pounderUtilities.getProjectLayoutType)(projectId, getState().members, (0, _pounderFirebase.getUserUid)()) === 'global' ? projectId : (0, _pounderFirebase.getUserUid)();
      var projectLayoutRef = getProjectLayoutRef(getFirestore, getState, projectId).doc(targetProjectLayoutId);
      batch.update(projectLayoutRef, {
        layouts: newTrimmedLayouts
      });
      batch.commit().then(function () {// Carefull what you do here, promises don't resolve if you are offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      });
    }
  };
}

function updateTaskNameAsync(taskId, newValue, currentValue, currentMetadata) {
  return (
    /*#__PURE__*/
    function () {
      var _ref87 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee25(dispatch, getState, _ref86) {
        var getFirestore, getAuth, getDexie, getFunctions, update, newUpdate, taskRef;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                getFirestore = _ref86.getFirestore, getAuth = _ref86.getAuth, getDexie = _ref86.getDexie, getFunctions = _ref86.getFunctions;
                // Coerce.
                newValue = newValue === '' ? currentValue : newValue;
                update = {
                  taskName: newValue,
                  isNewTask: false,
                  // Reset new Task Property.
                  metadata: getUpdatedMetadata(currentMetadata, {
                    updatedBy: getState().displayName,
                    updatedOn: getHumanFriendlyDate()
                  }) // Returns a new Update Object with arguments parsed in (if any);

                };
                newUpdate = parseArgumentsIntoUpdate(getState, update); // Update Firestore.

                taskRef = getTaskRef(getFirestore, getState, taskId);
                taskRef.update(newUpdate).then(function () {// Carefull what you do here, promises don't resolve if you are offline.
                })["catch"](function (error) {
                  handleFirebaseUpdateError(error, getState(), dispatch);
                }); // Project updated metadata.

                updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);

              case 7:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      return function (_x79, _x80, _x81) {
        return _ref87.apply(this, arguments);
      };
    }()
  );
}

function updateTaskNameWithDialogAsync(taskId, currentValue, currentMetadata) {
  return (
    /*#__PURE__*/
    function () {
      var _ref89 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee26(dispatch, getState, _ref88) {
        var getFirestore, getAuth, getDexie, getFunctions, dialogResult, newValue;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                getFirestore = _ref88.getFirestore, getAuth = _ref88.getAuth, getDexie = _ref88.getDexie, getFunctions = _ref88.getFunctions;
                _context26.next = 3;
                return postTextInputDialog(dispatch, getState(), "Name", currentValue, "Edit Task name");

              case 3:
                dialogResult = _context26.sent;

                if (dialogResult.result === "okay") {
                  newValue = dialogResult.value;
                  dispatch(updateTaskNameAsync(taskId, newValue, currentValue, currentMetadata));
                }

              case 5:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      return function (_x82, _x83, _x84) {
        return _ref89.apply(this, arguments);
      };
    }()
  );
}

function removeSelectedTaskAsync() {
  return function (dispatch, getState, _ref90) {
    var getFirestore = _ref90.getFirestore,
        getAuth = _ref90.getAuth,
        getDexie = _ref90.getDexie,
        getFunctions = _ref90.getFunctions;
    var taskId = getState().selectedTask.taskId;

    if (taskId !== -1) {
      deleteTaskAsync(dispatch, getFirestore, getState, getDexie, taskId).then(function () {// Careful what you do here. Promises don't resolve Offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      });
      dispatch(selectTask(getState().focusedTaskListId, -1, false)); // Project updated metadata.

      updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
    }
  };
}

function removeTaskAsync(taskId) {
  return function (dispatch, getState, _ref91) {
    var getFirestore = _ref91.getFirestore,
        getAuth = _ref91.getAuth,
        getDexie = _ref91.getDexie,
        getFunctions = _ref91.getFunctions;

    if (taskId !== -1) {
      deleteTaskAsync(dispatch, getFirestore, getState, getDexie, taskId).then(function () {// Careful what you do here. Promises don't resolve Offline.
      })["catch"](function (error) {
        handleFirebaseUpdateError(error, getState(), dispatch);
      });
      dispatch(selectTask(getState().focusedTaskListId, -1, false)); // Project updated metadata.

      updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
    }
  };
}

function deleteTaskAsync(_x85, _x86, _x87, _x88, _x89) {
  return _deleteTaskAsync.apply(this, arguments);
}

function _deleteTaskAsync() {
  _deleteTaskAsync = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee34(dispatch, getFirestore, getState, getDexie, taskId) {
    var taskRef;
    return regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            // Undo Stack
            taskRef = getTaskRef(getFirestore, getState, taskId);
            pushUndoActionAsync(dispatch, getState, getFirestore, getDexie, {
              type: 'taskDelete',
              refPath: taskRef.path,
              friendlyText: 'task delete'
            }); // Project updated metadata.

            updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
            _context34.prev = 3;
            _context34.next = 6;
            return taskRef.update({
              isDeleted: true
            });

          case 6:
            _context34.next = 11;
            break;

          case 8:
            _context34.prev = 8;
            _context34.t0 = _context34["catch"](3);
            handleFirebaseUpdateError(_context34.t0, getState(), dispatch);

          case 11:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, null, [[3, 8]]);
  }));
  return _deleteTaskAsync.apply(this, arguments);
}

function updateTaskListNameAsync(taskListId, currentName) {
  return (
    /*#__PURE__*/
    function () {
      var _ref93 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee27(dispatch, getState, _ref92) {
        var getFirestore, getAuth, getDexie, getFunctions, dialogResult, newName, taskListRef;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                getFirestore = _ref92.getFirestore, getAuth = _ref92.getAuth, getDexie = _ref92.getDexie, getFunctions = _ref92.getFunctions;
                _context27.next = 3;
                return postTextInputDialog(dispatch, getState(), 'Name', currentName, 'Rename List');

              case 3:
                dialogResult = _context27.sent;

                if (!(dialogResult.result === 'cancel')) {
                  _context27.next = 6;
                  break;
                }

                return _context27.abrupt("return");

              case 6:
                newName = dialogResult.value;

                if (!(newName !== currentName)) {
                  _context27.next = 18;
                  break;
                }

                taskListRef = getTaskListRef(getFirestore, getState, taskListId); // Project updated metadata.

                updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
                _context27.prev = 10;
                _context27.next = 13;
                return taskListRef.update({
                  taskListName: newName
                });

              case 13:
                _context27.next = 18;
                break;

              case 15:
                _context27.prev = 15;
                _context27.t0 = _context27["catch"](10);
                handleFirebaseUpdateError(_context27.t0, getState(), dispatch);

              case 18:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[10, 15]]);
      }));

      return function (_x90, _x91, _x92) {
        return _ref93.apply(this, arguments);
      };
    }()
  );
}

function moveTaskViaDialogAsync(taskId, sourceTaskListId, sourceProjectId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref95 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee28(dispatch, getState, _ref94) {
        var getFirestore, getAuth, getDexie, getFunctions, lists, items, dialogResult, destinationTaskListId;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                getFirestore = _ref94.getFirestore, getAuth = _ref94.getAuth, getDexie = _ref94.getDexie, getFunctions = _ref94.getFunctions;
                lists = getState().taskLists.filter(function (item) {
                  return item.project === sourceProjectId && item.uid !== sourceTaskListId;
                });
                items = lists.map(function (item) {
                  return {
                    value: item.uid,
                    primaryText: item.taskListName
                  };
                });
                _context28.next = 5;
                return postQuickItemSelectDialog(dispatch, getState(), "Select List", '', items, "Cancel");

              case 5:
                dialogResult = _context28.sent;

                if (!(dialogResult.result === 'negative')) {
                  _context28.next = 8;
                  break;
                }

                return _context28.abrupt("return");

              case 8:
                destinationTaskListId = dialogResult.value;
                dispatch(moveTaskAsync(taskId, destinationTaskListId));

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      return function (_x93, _x94, _x95) {
        return _ref95.apply(this, arguments);
      };
    }()
  );
}

function moveTaskAsync(taskId, destinationTaskListId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref97 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee29(dispatch, getState, _ref96) {
        var getFirestore, getAuth, getDexie, getFunctions, currentMetadata, taskRef;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                getFirestore = _ref96.getFirestore, getAuth = _ref96.getAuth, getDexie = _ref96.getDexie, getFunctions = _ref96.getFunctions;

                if (!(destinationTaskListId === -1)) {
                  _context29.next = 3;
                  break;
                }

                return _context29.abrupt("return");

              case 3:
                // Extract metadata.
                currentMetadata = getState().tasks.find(function (item) {
                  return item.uid === taskId;
                }).metadata;
                dispatch(setFocusedTaskListId(destinationTaskListId)); // Project updated metadata.

                updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
                taskRef = getTaskRef(getFirestore, getState, taskId);
                _context29.prev = 7;
                _context29.next = 10;
                return taskRef.update({
                  taskList: destinationTaskListId,
                  metadata: getUpdatedMetadata(currentMetadata, {
                    updatedBy: getState().displayName,
                    updatedOn: getHumanFriendlyDate()
                  })
                });

              case 10:
                _context29.next = 15;
                break;

              case 12:
                _context29.prev = 12;
                _context29.t0 = _context29["catch"](7);
                handleFirebaseUpdateError(_context29.t0, getState(), dispatch);

              case 15:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, null, [[7, 12]]);
      }));

      return function (_x96, _x97, _x98) {
        return _ref97.apply(this, arguments);
      };
    }()
  );
}

function getLastUndoActionAsync() {
  return (
    /*#__PURE__*/
    function () {
      var _ref99 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee30(dispatch, getState, _ref98) {
        var getFirestore, getAuth, getDexie, getFunctions, value;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                getFirestore = _ref98.getFirestore, getAuth = _ref98.getAuth, getDexie = _ref98.getDexie, getFunctions = _ref98.getFunctions;
                _context30.next = 3;
                return getDexie().lastUndoAction.get('0');

              case 3:
                value = _context30.sent;
                dispatch(setLastUndoAction(value));

              case 5:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));

      return function (_x99, _x100, _x101) {
        return _ref99.apply(this, arguments);
      };
    }()
  );
}

function addNewTaskAsync() {
  return (
    /*#__PURE__*/
    function () {
      var _ref101 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee31(dispatch, getState, _ref100) {
        var getFirestore, getAuth, getDexie, getFunctions, _getState, focusedTaskListId, selectedProjectId, dialogResult, taskName, newTaskRef, metadata, parsedUpdate, parsedTaskName, parsedDueDate, parsedPriority, newTaskKey, newTask;

        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                getFirestore = _ref100.getFirestore, getAuth = _ref100.getAuth, getDexie = _ref100.getDexie, getFunctions = _ref100.getFunctions;
                dispatch(setShowOnlySelfTasks(false));
                _getState = getState(), focusedTaskListId = _getState.focusedTaskListId, selectedProjectId = _getState.selectedProjectId;

                if (!(selectedProjectId !== -1 && focusedTaskListId !== -1)) {
                  _context31.next = 8;
                  break;
                }

                _context31.next = 6;
                return postTextInputDialog(dispatch, getState(), "Name", "", "Create Task");

              case 6:
                dialogResult = _context31.sent;

                if (dialogResult.result === "okay") {
                  taskName = dialogResult.value; // Coerce.

                  taskName = taskName === '' ? 'My Task' : taskName; // Add new Task.

                  if (isProjectRemote(getState, getState().selectedProjectId)) {
                    newTaskRef = getFirestore().collection(_paths.REMOTES).doc(getState().selectedProjectId).collection(_paths.TASKS).doc();
                  } else {
                    newTaskRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS).doc();
                  }

                  metadata = new _pounderStores.TaskMetadataStore(getState().displayName, getHumanFriendlyDate(new Date()), "", "", "", ""); // Parse Arguments into an Update Object.

                  parsedUpdate = parseArgumentsIntoUpdate(getState, {
                    taskName: taskName,
                    dueDate: "",
                    isHighPriority: false
                  });
                  parsedTaskName = parsedUpdate.taskName;
                  parsedDueDate = parsedUpdate.dueDate;
                  parsedPriority = parsedUpdate.isHighPriority;
                  newTaskKey = newTaskRef.id;
                  newTask = new _pounderStores.TaskStore(parsedTaskName, parsedDueDate, false, selectedProjectId, focusedTaskListId, newTaskKey, new _moment["default"]().toISOString(), false, parsedPriority, Object.assign({}, metadata), -1, []);
                  newTaskRef.set(Object.assign({}, newTask)).then(function () {})["catch"](function (error) {
                    handleFirebaseUpdateError(error, getState(), dispatch);
                  }); // Project updated metadata.

                  updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
                }

              case 8:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      return function (_x102, _x103, _x104) {
        return _ref101.apply(this, arguments);
      };
    }()
  );
}

function addNewTaskListAsync(suppressMetadataUpdate) {
  return (
    /*#__PURE__*/
    function () {
      var _ref103 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee32(dispatch, getState, _ref102) {
        var getFirestore, getAuth, getDexie, getFunctions, selectedProjectId, dialogResult, taskListName, batch, newTaskListRef, newTaskList;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                getFirestore = _ref102.getFirestore, getAuth = _ref102.getAuth, getDexie = _ref102.getDexie, getFunctions = _ref102.getFunctions;
                dispatch(setShowOnlySelfTasks(false));
                selectedProjectId = getState().selectedProjectId;

                if (!(selectedProjectId !== -1)) {
                  _context32.next = 8;
                  break;
                }

                _context32.next = 6;
                return postTextInputDialog(dispatch, getState(), "List name", "", "Create List");

              case 6:
                dialogResult = _context32.sent;

                if (dialogResult.result === "okay") {
                  taskListName = dialogResult.value; // Add to Firestore.

                  batch = getFirestore().batch();

                  if (isProjectRemote(getState, selectedProjectId)) {
                    newTaskListRef = getFirestore().collection(_paths.REMOTES).doc(selectedProjectId).collection(_paths.TASKLISTS).doc();
                  } else {
                    newTaskListRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc();
                  }

                  newTaskList = new _pounderStores.TaskListStore(taskListName, selectedProjectId, newTaskListRef.id, newTaskListRef.id, Object.assign({}, new _pounderStores.TaskListSettingsStore(true, "date added", (0, _pounderStores.ChecklistSettingsFactory)(false, "", "", 1))));
                  batch.set(newTaskListRef, _objectSpread({}, newTaskList)); // Add a new Entry into the ProjectLayouts for this Task List.

                  addProjectLayoutEntriesToBatch(batch, selectedProjectId, newTaskListRef.id, getFirestore, getState);
                  batch.commit().then(function () {// Careful what you do here, promises don't resolve if you are offline.
                  })["catch"](function (error) {
                    handleFirebaseUpdateError(error, getState(), dispatch);
                  });
                  dispatch(setFocusedTaskListId(newTaskListRef.id)); // Project updated metadata.

                  if (suppressMetadataUpdate === false) {
                    updateProjectUpdatedTime(getState, getFirestore, getState().selectedProjectId);
                  }
                }

              case 8:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      return function (_x105, _x106, _x107) {
        return _ref103.apply(this, arguments);
      };
    }()
  );
}

function getAccountConfigAsync() {
  return function (dispatch, getState, _ref104) {
    var getFirestore = _ref104.getFirestore,
        getAuth = _ref104.getAuth,
        getDexie = _ref104.getDexie,
        getFunctions = _ref104.getFunctions;
    accountConfigUnsubscribe = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.ACCOUNT).doc(_paths.ACCOUNT_DOC_ID).onSnapshot(function (doc) {
      if (doc.exists) {
        var accountConfig = doc.data();
        dispatch(receiveAccountConfig(accountConfig)); // Dexie returns numbers as strings. Convert "-1" to a number if required.

        var favouriteProjectId = accountConfig.favouriteProjectId === "-1" ? -1 : accountConfig.favouriteProjectId;

        if (favouriteProjectId !== -1) {
          dispatch(selectProject(favouriteProjectId));

          if (HANDBALL_DEVICE === "mobile" && favouriteProjectId !== -1) {
            dispatch(setIsAppDrawerOpen(false));
            dispatch(setIsAppSettingsOpen(false));
          }
        }
      }
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function getProjectsAsync() {
  return function (dispatch, getState, _ref105) {
    var getFirestore = _ref105.getFirestore,
        getAuth = _ref105.getAuth,
        getDexie = _ref105.getDexie,
        getFunctions = _ref105.getFunctions;
    dispatch(startProjectsFetch()); // Get Projects from Firestore.

    localProjectsUnsubscribe = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTS).onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      // Handle metadata.
      dispatch(setProjectsHavePendingWrites(snapshot.metadata.hasPendingWrites));

      if (snapshot.docChanges().length > 0) {
        var projects = [];
        snapshot.forEach(function (doc) {
          var data = doc.data();

          if (data.isDeleted === true) {
            return;
          }

          projects.push(data);
        });
        dispatch(receiveLocalProjects(projects));
      }
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function getIncompletedLocalTasksAsync() {
  return function (dispatch, getState, _ref106) {
    var getFirestore = _ref106.getFirestore,
        getAuth = _ref106.getAuth,
        getDexie = _ref106.getDexie,
        getFunctions = _ref106.getFunctions;
    dispatch(startTasksFetch()); // Get Tasks from Firestore.

    var tasksRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS); // Get only completed Tasks.

    onlyIncompletedLocalTasksUnsubscribe = tasksRef.where('isComplete', '==', false).orderBy("project").onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      handleTasksSnapshot(getState, dispatch, false, snapshot, undefined, 'incompletedOnly');
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function getCompletedLocalTasksAsync() {
  return function (dispatch, getState, _ref107) {
    var getFirestore = _ref107.getFirestore,
        getAuth = _ref107.getAuth,
        getDexie = _ref107.getDexie,
        getFunctions = _ref107.getFunctions;
    dispatch(startTasksFetch()); // Get Tasks from Firestore.

    var tasksRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS); // Get only completed Tasks.

    onlyCompletedLocalTasksUnsubscribe = tasksRef.where('isComplete', '==', true).orderBy("project").onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      handleTasksSnapshot(getState, dispatch, false, snapshot, undefined, 'completedOnly');
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function handleTasksSnapshot(getState, dispatch, isRemote, snapshot, remoteProjectId, type) {
  // Handle Metadata.
  if (snapshot.metadata !== undefined) {
    dispatch(setTasksHavePendingWrites(snapshot.metadata.hasPendingWrites));
  } // Handle Tasks.


  if (snapshot.docChanges().length > 0) {
    var tasks = [];
    snapshot.forEach(function (doc) {
      var task = doc.data();

      if (task.isDeleted) {
        return;
      } // Coercion


      task.dueDate = task.dueDate === null ? "" : task.dueDate;
      task.metadata = task.metadata === undefined ? _objectSpread({}, new _pounderStores.TaskMetadataStore("", "", "", "", "", "")) : task.metadata;
      task.commentPreview = task.commentPreview === undefined ? [] : task.commentPreview;
      tasks.push(task);
    }); // Remote

    if (isRemote) {
      if (type === 'completedOnly') {
        dispatch(receiveCompletedRemoteTasks(mergeRemoteTasks(getState().completedRemoteTasks, tasks, remoteProjectId)));
      }

      if (type === 'incompletedOnly') {
        dispatch(receiveIncompletedRemoteTasks(mergeRemoteTasks(getState().incompletedRemoteTasks, tasks, remoteProjectId)));
      }
    } // Local
    else {
        if (type === 'completedOnly') {
          dispatch(receiveCompletedLocalTasks(tasks));
        }

        if (type === 'incompletedOnly') {
          dispatch(receiveIncompletedLocalTasks(tasks));
        }
      }
  }
}

function mergeRemoteTasks(mergeTarget, newTasks, remoteProjectId) {
  var filteredTasks = mergeTarget.filter(function (item) {
    return item.project !== remoteProjectId;
  });
  return [].concat(_toConsumableArray(filteredTasks), _toConsumableArray(newTasks));
}

function getTaskListsAsync(projectId) {
  return function (dispatch, getState, _ref108) {
    var getFirestore = _ref108.getFirestore,
        getAuth = _ref108.getAuth,
        getDexie = _ref108.getDexie,
        getFunctions = _ref108.getFunctions;
    dispatch(startTaskListsFetch()); // Get Tasklists from Firestore.

    localTaskListsUnsubscribe = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      handleTaskListsSnapshot(getState, dispatch, false, snapshot, projectId);
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function handleTaskListsSnapshot(getState, dispatch, isRemote, snapshot, remoteProjectId) {
  // Handle Metadata.
  if (snapshot.metadata !== undefined) {
    dispatch(setTaskListsHavePendingWrites(snapshot.metadata.hasPendingWrites));
  }

  if (snapshot.docChanges().length > 0) {
    var taskLists = [];
    var checklists = [];
    snapshot.forEach(function (doc) {
      if (doc.data().isMoving) {
        // Task list has been moved to another Project but Cloud function has not cleaned it up yet, don't add it to
        // State.
        return;
      }

      if (doc.data().isDeleted) {
        return;
      }

      var taskList = coerceTaskList(doc.data());
      taskLists.push(taskList); // Keep track of checklists.

      if (taskList.settings.checklistSettings.isChecklist) {
        checklists.push(taskList);
      }

      ;
    });

    if (isRemote) {
      var filteredTaskLists = getState().remoteTaskLists.filter(function (item) {
        return item.project !== remoteProjectId;
      });
      taskLists = [].concat(_toConsumableArray(taskLists), _toConsumableArray(filteredTaskLists));
      dispatch(receiveRemoteTaskLists(taskLists)); // Renew any checklists requring renewel.

      processChecklists(dispatch, checklists, true, remoteProjectId);
    } else {
      dispatch(receiveLocalTaskLists(taskLists)); // Renew any checklists requring renewel.

      processChecklists(dispatch, checklists, false, null);
    }
  }
}

function processChecklists(dispatch, checklists, isRemote, remoteProjectId) {
  checklists.forEach(function (item) {
    if ((0, _pounderUtilities.isChecklistDueForRenew)(item.settings.checklistSettings)) {
      dispatch(renewChecklistAsync(item, isRemote, remoteProjectId, false));
    }
  });
}

function coerceTaskList(taskList) {
  var workingTaskList = _objectSpread({}, taskList);

  if (taskList.settings.checklistSettings === undefined) {
    workingTaskList.settings.checklistSettings = (0, _pounderStores.ChecklistSettingsFactory)(false, "", "", 1);
  }

  return workingTaskList;
}

function getLocalProjectLayoutsAsync() {
  return function (dispatch, getState, _ref109) {
    var getFirestore = _ref109.getFirestore,
        getAuth = _ref109.getAuth,
        getDexie = _ref109.getDexie,
        getFunctions = _ref109.getFunctions;
    dispatch(startProjectLayoutsFetch());
    var projectLayoutsRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTLAYOUTS);
    localProjectLayoutsUnsubscribe = projectLayoutsRef.onSnapshot(_index2.includeMetadataChanges, function (snapshot) {
      handleProjectLayoutsSnapshot(getState, dispatch, false, snapshot);
    }, function (error) {
      handleFirebaseSnapshotError(error, getState(), dispatch);
    });
  };
}

function handleProjectLayoutsSnapshot(getState, dispatch, isRemote, snapshot, remoteProjectId) {
  // Handle Metadata.
  dispatch(setProjectLayoutsHavePendingWrites(snapshot.metadata.hasPendingWrites));

  if (snapshot.docChanges().length > 0) {
    var projectLayouts = [];

    if (snapshot.empty !== true) {
      snapshot.forEach(function (doc) {
        projectLayouts.push(doc.data());
      });
    }

    if (isRemote) {
      var filteredProjectLayouts = getState().remoteProjectLayouts.filter(function (item) {
        return item.project !== remoteProjectId;
      });
      projectLayouts = [].concat(_toConsumableArray(projectLayouts), _toConsumableArray(filteredProjectLayouts));
      dispatch(receiveRemoteProjectLayouts(projectLayouts));
    } else {
      dispatch(receiveLocalProjectLayouts(projectLayouts));
    }
  }
}

function unsubscribeAccountConfigAsync() {
  return function (dispatch, getState, _ref110) {
    var getFirestore = _ref110.getFirestore,
        getAuth = _ref110.getAuth,
        getDexie = _ref110.getDexie,
        getFunctions = _ref110.getFunctions;

    if (accountConfigUnsubscribe !== null) {
      accountConfigUnsubscribe();
    }
  };
}

function unsubscribeProjectsAsync() {
  return function (dispatch, getState, _ref111) {
    var getFirestore = _ref111.getFirestore,
        getAuth = _ref111.getAuth,
        getDexie = _ref111.getDexie,
        getFunctions = _ref111.getFunctions;

    if (localProjectsUnsubscribe !== null) {
      localProjectsUnsubscribe();
    }
  };
}

function unsubscribeTaskListsAsync() {
  return function (dispatch, getState, _ref112) {
    var getFirestore = _ref112.getFirestore,
        getAuth = _ref112.getAuth,
        getDexie = _ref112.getDexie,
        getFunctions = _ref112.getFunctions;

    if (localTaskListsUnsubscribe !== null) {
      localTaskListsUnsubscribe();
    }
  };
}

function unsubscribeTasksAsync() {
  return function (dispatch, getState, _ref113) {
    var getFirestore = _ref113.getFirestore,
        getAuth = _ref113.getAuth,
        getDexie = _ref113.getDexie,
        getFunctions = _ref113.getFunctions;

    if (onlyCompletedLocalTasksUnsubscribe !== null) {
      onlyCompletedLocalTasksUnsubscribe();
    }

    if (onlyIncompletedLocalTasksUnsubscribe !== null) {
      onlyIncompletedLocalTasksUnsubscribe();
    }
  };
}

function unsubscribeInvitesAsync() {
  return function (dispatch, getState, _ref114) {
    var getFirestore = _ref114.getFirestore,
        getAuth = _ref114.getAuth,
        getDexie = _ref114.getDexie,
        getFunctions = _ref114.getFunctions;

    if (invitesUnsubscribe !== null) {
      invitesUnsubscribe();
    }
  };
}

function unsubscribeProjectLayoutsAsync() {
  return function (dispatch, getState, _ref115) {
    var getFirestore = _ref115.getFirestore,
        getAuth = _ref115.getAuth,
        getDexie = _ref115.getDexie,
        getFunctions = _ref115.getFunctions;

    if (localProjectLayoutsUnsubscribe !== null) {
      localProjectLayoutsUnsubscribe();
    }
  };
} // Helper Functions.


function isRemovingLastTaskList(getState, projectId) {
  var filteredTaskLists = [];
  filteredTaskLists = getState().taskLists.filter(function (item) {
    return item.project === projectId;
  });
  return filteredTaskLists.length === 1;
}

function compareProjectLayouts(layoutsA, layoutsB) {
  var layoutsAJSON = JSON.stringify(layoutsA);
  var layoutsBJSON = JSON.stringify(layoutsB);
  return layoutsAJSON === layoutsBJSON;
}

function extractProject(getState, projectId) {
  return getState().projects.find(function (item) {
    return item.uid === projectId;
  });
}

function updateProjectUpdatedTime(getState, getFirestore, projectId) {
  var ref = getProjectRef(getFirestore, getState, projectId);
  ref.update({
    updated: new Date().toISOString()
  }).then(function () {// Careful what you do here, promises don't resolve Offline.
  })["catch"](function (error) {
    handleFirebaseUpdateError(error, getState(), dispatch);
  });
}

function addUpdatingInviteId(dispatch, getState, inviteId) {
  var oldUpdatingInviteIds = getState().updatingInviteIds;

  if (oldUpdatingInviteIds.includes(inviteId) === false) {
    var newUpdatingInviteIds = _toConsumableArray(oldUpdatingInviteIds);

    newUpdatingInviteIds.push(inviteId);
    dispatch(setUpdatingInviteIds(newUpdatingInviteIds));
  }
}

function removeUpdatingInviteId(dispatch, getState, inviteId) {
  var oldUpdatingInviteIds = getState().updatingInviteIds;
  var newUpdatingInviteIds = [];
  var index = oldUpdatingInviteIds.findIndex(function (id) {
    return id === inviteId;
  });

  if (index !== -1) {
    newUpdatingInviteIds = _toConsumableArray(oldUpdatingInviteIds);
    newUpdatingInviteIds.splice(index, 1);
    dispatch(setUpdatingInviteIds(newUpdatingInviteIds));
  }
}

function addUpdatingUserId(dispatch, getState, userId, projectId) {
  var oldUpdatingUserIds = getState().updatingUserIds;
  var newUpdatingUserIds = [];
  var alreadyExists = oldUpdatingUserIds.some(function (item) {
    return item.projectId === projectId && item.userId === userId;
  });

  if (!alreadyExists) {
    newUpdatingUserIds = _toConsumableArray(oldUpdatingUserIds);
    newUpdatingUserIds.push({
      projectId: projectId,
      userId: userId
    });
    dispatch(setUpdatingUserIds(newUpdatingUserIds));
  }
}

function removeUpdatingUserId(dispatch, getState, userId, projectId) {
  var oldUpdatingUserIds = getState().updatingUserIds;
  var newUpdatingUserIds = [];
  var index = oldUpdatingUserIds.findIndex(function (item) {
    return item.projectId === projectId && item.userId === userId;
  });

  if (index !== -1) {
    newUpdatingUserIds = _toConsumableArray(oldUpdatingUserIds);
    newUpdatingUserIds.splice(index, 1);
    dispatch(setUpdatingUserIds(newUpdatingUserIds));
  }
} // Determine if an update to the Metadata should occur. Updates should be ignored for a set ammount of time after a Task is
// created to stop CreatedAt and UpdatedAt times being the same or very similiar.


function shouldUpdateMetadata(currentMetadata) {
  if (currentMetadata.createdOn === undefined || currentMetadata.createdOn === null || currentMetadata.createdOn === "") {
    return true;
  } // Determine Difference.


  var createdOn = (0, _moment["default"])(currentMetadata.createdOn, DATE_FORMAT);
  var now = (0, _moment["default"])();
  return now.diff(createdOn, 'seconds') > 120;
}

function getUpdatedMetadata(currentMetadata, update) {
  // Coerce currentMetadata to a Valid object.
  if (currentMetadata === undefined) {
    currentMetadata = Object.assign({}, new _pounderStores.TaskMetadataStore("", "", "", "", "", ""));
  }

  if (currentMetadata['completedOn'] === undefined) {
    currentMetadata['completedOn'] = "";
  }

  if (shouldUpdateMetadata(currentMetadata)) {
    // Merge update into currentMetadata.
    for (var propertyName in update) {
      currentMetadata[propertyName] = update[propertyName];
    }
  }

  return currentMetadata;
}

function getHumanFriendlyDate(jsDate) {
  if (jsDate === undefined) {
    jsDate = new Date();
  }

  var date = (0, _moment["default"])(jsDate).format(DATE_FORMAT);
  return date;
}

function getProjectRef(getFirestore, getState, projectId) {
  if (isProjectRemote(getState, projectId)) {
    return getFirestore().collection(_paths.REMOTES).doc(projectId);
  } else {
    return getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTS).doc(projectId);
  }
}

function getProjectLayoutRef(getFirestore, getState, projectId) {
  if (isProjectRemote(getState, projectId)) {
    return getFirestore().collection(_paths.REMOTES).doc(projectId).collection(_paths.PROJECTLAYOUTS);
  } else {
    return getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.PROJECTLAYOUTS);
  }
}

function getTaskRef(getFirestore, getState, taskId) {
  var selectedProjectId = getState().selectedProjectId;

  if (isProjectRemote(getState, selectedProjectId)) {
    return getFirestore().collection(_paths.REMOTES).doc(selectedProjectId).collection(_paths.TASKS).doc(taskId);
  } else {
    return getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS).doc(taskId);
  }
}

function getTaskListRef(getFirestore, getState, taskListId) {
  var selectedProjectId = getState().selectedProjectId;

  if (isProjectRemote(getState, selectedProjectId)) {
    return getFirestore().collection(_paths.REMOTES).doc(selectedProjectId).collection(_paths.TASKLISTS).doc(taskListId);
  } else {
    return getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc(taskListId);
  }
}

function isProjectRemote(getState, projectId) {
  var index = getState().remoteProjectIds.findIndex(function (id) {
    return id === projectId;
  });
  return index !== -1;
}

function handleFirebaseSnapshotError(error, state, dispatch) {
  switch (error.code) {
    case "permission-denied":
      if (state.isLoggedIn) {
        postGeneralSnackbar(dispatch, state, 'error', 'An error occured: ' + error.message, 0, 'Dismiss');
      } // No handling required if logged out. Expected behaviour.


      break;

    default:
      throw error;
  }
}

function handleFirebaseUpdateError(error, state, dispatch) {
  switch (error.code) {
    case "permission-denied":
      if (state.isLoggedIn) {
        postGeneralSnackbar(dispatch, state, 'error', "".concat(error.code, " : ").concat(error.message), 0, 'Dismiss');
      } else {
        var _message3 = "You must log in first.";
        postGeneralSnackbar(dispatch, state, 'information', 'You must log in first', 4000, '');
      }

    default:
      throw error;
  }
}

function handleAuthError(dispatch, state, error) {
  switch (error.code) {
    case "auth/wrong-password":
      postGeneralSnackbar(dispatch, state, 'information', 'Incorrect password', 4000, '');
      break;

    case "auth/no-user-found":
      postGeneralSnackbar(dispatch, state, 'information', 'No user matching that email was found', 4000, '');
      break;

    case "auth/invalid-email":
      postGeneralSnackbar(dispatch, state, 'information', 'Invalid email', 4000, '');
      break;

    case "auth/network-request-failed":
      postGeneralSnackbar(dispatch, state, 'information', 'Cannot reach the Authentication servers', 4000, '');
      break;

    case "auth/email-already-in-use":
      postGeneralSnackbar(dispatch, state, 'information', 'Email address already in use', 4000, '');
      break;

    case "auth/weak-password":
      postGeneralSnackbar(dispatch, state, 'information', 'Password to short', 4000, '');
      break;

    case "auth/user-disabled":
      postGeneralSnackbar(dispatch, state, 'information', 'Password to short. Must be 6 characters or more', 4000, '');
      break;

    default:
      postGeneralSnackbar(dispatch, state, 'error', "".concat(error.code, " : ").concat(error.message), 0, 'Dismiss');
  }
}

function extractCurrentMetadata(state, taskId) {
  var tasks = state.tasks;
  var targetTask = tasks.find(function (item) {
    return item.uid === taskId;
  });
  return targetTask === undefined ? undefined : targetTask.metadata;
}

function parseArgumentsIntoUpdate(getState, update) {
  // Search for Arguments in taskName.
  var taskName = update.taskName;
  var argumentStartIndex = getArgumentsStartIndex(taskName);

  if (argumentStartIndex === -1) {
    // No Arguments Found. Bail out.
    return update;
  } // Split Arguments from from Normal Task Name.


  var taskSubstring = taskName.substring(0, argumentStartIndex);
  var argumentsSubstring = taskName.substring(argumentStartIndex); // Coerce Values.

  taskSubstring = taskSubstring === undefined ? "" : taskSubstring;
  argumentsSubstring = argumentsSubstring === undefined ? "" : argumentsSubstring; // Convert string into args array.

  var args = (0, _stringArgv["default"])(argumentsSubstring); // Parse arguments.

  var argv = (0, _minimist["default"])(args); // Merge arguments with provided update.

  var parsedUpdate = _objectSpread({}, update); // dueDate.


  if (argv.d !== undefined) {
    parsedUpdate.dueDate = parseDateArgument(argv.d);
  } // isHighPriority


  if (argv.p !== undefined) {
    parsedUpdate.isHighPriority = true;
  }

  if (argv.i !== undefined) {
    parsedUpdate.isHighPriority = true;
  } // Note.


  if (argv.n !== undefined) {
    parsedUpdate.note = argv.n;
  } // Assign Task to.


  if (argv.a !== undefined) {
    if (argv.a === true) {
      // Clear AssignedTo.
      parsedUpdate.assignedTo = -1;
    } else if (argv.a !== null && argv.a.trim() !== "") {
      // Fuzzy search for a userId.
      var userId = fuzzyMatchUserId(getState, argv.a);

      if (userId !== undefined && userId !== -1) {
        // Match found.
        parsedUpdate.assignedTo = userId;
      }
    }
  } // Set taskName to everything except the arguments.


  parsedUpdate.taskName = taskSubstring; // Override with Lorem Ipsum Text if in Dev.

  if (process.env.NODE_ENV === 'development') {
    if (argv.l !== undefined) {
      if (argv.l === true) {
        parsedUpdate.taskName = loremIpsum({
          count: 1,
          random: Math.random
        });
      } else {
        parsedUpdate.taskName = loremIpsum({
          count: argv.l,
          random: Math.random
        });
      }
    }
  }

  return parsedUpdate;
}

function getArgumentsStartIndex(taskName) {
  var regex = / -[a-zA-Z]/; // Search for Whitepace THEN Hypen THEN Any Alphanumeric Character.

  var match = regex.exec(taskName);

  if (match) {
    return match.index;
  } else {
    return -1;
  }
}

function fuzzyMatchUserId(getState, entry) {
  // Fuzzy search through members for a match.
  var selectedProjectId = getState().selectedProjectId;
  var filteredMembers = getState().members.filter(function (item) {
    return item.project === selectedProjectId;
  }); // Add some entries for user typing 'me' or 'myself'.. and irene.

  filteredMembers.push({
    displayName: 'me',
    userId: (0, _pounderFirebase.getUserUid)()
  });
  filteredMembers.push({
    displayName: 'myself',
    userId: (0, _pounderFirebase.getUserUid)()
  });
  var options = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.6,
    location: 0,
    distance: 100,
    maxPatternLength: 16,
    minMatchCharLength: 1,
    keys: ["displayName"]
  };
  var fuse = new _fuse["default"](filteredMembers, options);
  var result = fuse.search(entry);

  if (result.length === 0) {
    // No Result Found.
    return -1;
  } else {
    return result[0].item.userId;
  }
}

function parseDateArgument(d) {
  // Clear Due Date.
  if (d === true) {
    // Clear due Date.
    return "";
  } // Number without 'd' suffix.


  if (typeof d === "number") {
    // Assume user means Days.
    return (0, _pounderUtilities.getDaysForwardDate)(d);
  }

  var value = d.toLowerCase(); // Today.

  if (value === "today") {
    return (0, _pounderUtilities.getDaysForwardDate)(0);
  } // Tomomrrow - Catch mispellings as well.


  if (value.includes('tom')) {
    return (0, _pounderUtilities.getDaysForwardDate)(1);
  } // Is a day Name.


  if ((0, _pounderUtilities.isDayName)(value)) {
    return (0, _pounderUtilities.getDayNameDate)(value);
  } // Date


  if (value.includes('/')) {
    return (0, _pounderUtilities.getParsedDate)(d);
  } // Days Forward.


  if (value.includes('d') || value.includes('day')) {
    return (0, _pounderUtilities.getDaysForwardDate)(d.slice(0, d.length - 1));
  } // Weeks Forward.


  if (value.includes('w')) {
    return (0, _pounderUtilities.getWeeksForwardDate)(d.slice(0, d.length - 1));
  }

  return "";
}

function collectProjectRelatedTaskIds(tasks, projectId) {
  return tasks.filter(function (task) {
    return task.project === projectId;
  }).map(function (task) {
    return task.uid;
  });
}

function collectTaskListRelatedTaskIds(tasks, taskListWidgetId) {
  // Collect related TaskIds.
  var taskIds = collectTaskListRelatedTasks(tasks, taskListWidgetId).map(function (task) {
    return task.uid;
  });
  return taskIds;
}

function collectTaskListRelatedTasks(tasks, taskListWidgetId) {
  // Collect related TaskIds.
  var tasks = tasks.filter(function (task) {
    return task.taskList === taskListWidgetId;
  });
  return tasks;
}

function sanitizeLayouts(layouts) {
  // Layouts from RGL come with Functions and undefined values as properties which can't be serialized to Firestore.
  var trimmedLayouts = layouts.map(function (item) {
    return {
      i: item.i,
      x: item.x,
      y: item.y,
      w: item.w,
      h: item.h
    };
  });
  return trimmedLayouts;
}

function syncAppToConfig(generalConfig, dispatch) {
  if (generalConfig.startLocked) {
    dispatch(lockApp());
  }

  dispatch(setIsStartingUpFlag(false));
}

function hasUserGotALocalLayout(state) {
  var selectedProjectId = state.selectedProjectId;
  return state.projectLayoutsMap[selectedProjectId][(0, _pounderFirebase.getUserUid)()] !== undefined;
}

function addProjectLayoutEntriesToBatch(batch, projectId, taskListId, getFirestore, getState) {
  var newLayoutEntry = (0, _pounderStores.LayoutEntryFactory)(taskListId); // Iterate through all layouts for this Project and add the entry to them.

  for (var uid in getState().projectLayoutsMap[projectId]) {
    var ref = getProjectLayoutRef(getFirestore, getState, projectId).doc(uid);

    var newLayouts = _toConsumableArray(getState().projectLayoutsMap[projectId][uid].layouts);

    newLayouts.push(newLayoutEntry);
    batch.update(ref, {
      layouts: newLayouts
    });
  }
}

function buildTaskListMoveRefs(sourceProjectId, targetProjectId, taskListWidgetId, getFirestore, getState) {
  var sourceTasksRef;
  var sourceTaskListRef;
  var targetTasksRef;
  var targetTaskListRef; // Source Project.

  if (isProjectRemote(getState, sourceProjectId) === true) {
    // Remote
    sourceTasksRef = getFirestore().collection(_paths.REMOTES).doc(sourceProjectId).collection(_paths.TASKS);
    sourceTaskListRef = getFirestore().collection(_paths.REMOTES).doc(sourceProjectId).collection(_paths.TASKLISTS).doc(taskListWidgetId);
  } else {
    // Local
    sourceTasksRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS);
    sourceTaskListRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc(taskListWidgetId);
  } // Target Project.


  if (isProjectRemote(getState, targetProjectId) === true) {
    // Remote
    targetTasksRef = getFirestore().collection(_paths.REMOTES).doc(targetProjectId).collection(_paths.TASKS);
    targetTaskListRef = getFirestore().collection(_paths.REMOTES).doc(targetProjectId).collection(_paths.TASKLISTS).doc(taskListWidgetId);
  } else {
    // Local
    targetTasksRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKS);
    targetTaskListRef = getFirestore().collection(_paths.USERS).doc((0, _pounderFirebase.getUserUid)()).collection(_paths.TASKLISTS).doc(taskListWidgetId);
  }

  return {
    source: {
      tasks: sourceTasksRef,
      taskList: sourceTaskListRef
    },
    target: {
      tasks: targetTasksRef,
      taskList: targetTaskListRef
    }
  };
}

function addProjectLayoutMovesToBatch(batch, sourceProjectId, targetProjectId, taskListWidgetId, getFirestore, getState) {
  // Move project Layout Entries.
  var sourceProjectLayouts = getState().projectLayoutsMap[sourceProjectId];
  var targetProjectLayouts = getState().projectLayoutsMap[targetProjectId]; // Delete Layout Entry from Source Project.

  for (var layoutId in sourceProjectLayouts) {
    var layouts = sourceProjectLayouts[layoutId].layouts;

    if (layouts) {
      var filteredLayouts = layouts.filter(function (item) {
        return item.i !== taskListWidgetId;
      });
      batch.update(getProjectLayoutRef(getFirestore, getState, sourceProjectId).doc(layoutId), {
        layouts: filteredLayouts
      });
    }
  } // Place new Layout in Target Project.


  for (var layoutId in targetProjectLayouts) {
    var layouts = targetProjectLayouts[layoutId].layouts;
    var newLayouts = []; // If Layouts already exist. Use it, else use a blank Array to start with.

    if (layouts) {
      newLayouts = _toConsumableArray(layouts);
    }

    newLayouts.push((0, _pounderStores.LayoutEntryFactory)(taskListWidgetId));
    batch.update(getProjectLayoutRef(getFirestore, getState, targetProjectId).doc(layoutId), {
      layouts: newLayouts
    });
  }
}

function postTextInputDialog(dispatch, state, label, text, title) {
  return new Promise(function (resolve, reject) {
    var onCancel = function onCancel() {
      dispatch(setTextInputDialog(false, state.textInputDialog.label, state.textInputDialog.text, state.textInputDialog.title, function () {}, function () {}));
      resolve({
        result: 'cancel',
        value: null
      });
    };

    var onOkay = function onOkay(newValue) {
      dispatch(setTextInputDialog(false, state.textInputDialog.label, state.textInputDialog.text, state.textInputDialog.title, function () {}, function () {}));
      resolve({
        result: 'okay',
        value: newValue
      });
    };

    dispatch(setTextInputDialog(true, label, text, title, onCancel, onOkay));
  });
}

function postInformationDialog(dispatch, state, text, title) {
  return new Promise(function (resolve, reject) {
    var onOkay = function onOkay(newValue) {
      dispatch(setInformationDialog(false, text, title, function () {}));
      resolve();
    };

    dispatch(setInformationDialog(true, text, title, onOkay));
  });
}

function postQuickItemSelectDialog(dispatch, state, title, text, items, negativeButtonText) {
  return new Promise(function (resolve, reject) {
    var onSelect = function onSelect(value) {
      dispatch(setQuickItemSelectDialog(false, title, text, items, negativeButtonText, function () {}, function () {}));
      resolve({
        result: 'affirmative',
        value: value
      });
    };

    var onNegative = function onNegative() {
      dispatch(setQuickItemSelectDialog(false, title, text, items, negativeButtonText, function () {}, function () {}));
      resolve({
        result: 'negative'
      });
    }; // Post dialog.


    dispatch(setQuickItemSelectDialog(true, title, text, items, negativeButtonText, onSelect, onNegative));
  });
}

function postItemSelectDialog(dispatch, state, title, text, items, affirmativeButtonText, negativeButtonText) {
  return new Promise(function (resolve, reject) {
    var onAffirmative = function onAffirmative(value) {
      dispatch(setItemSelectDialog(false, title, text, items, affirmativeButtonText, negativeButtonText, function () {}, function () {}));
      resolve({
        result: 'affirmative',
        value: value
      });
    };

    var onNegative = function onNegative() {
      dispatch(setItemSelectDialog(false, title, text, items, affirmativeButtonText, negativeButtonText, function () {}, function () {}));
      resolve({
        result: 'negative'
      });
    }; // Post dialog.


    dispatch(setItemSelectDialog(true, title, text, items, affirmativeButtonText, negativeButtonText, onAffirmative, onNegative));
  });
}

function postConfirmationDialog(dispatch, state, text, title, affirmativeButtonText, negativeButtonText) {
  return new Promise(function (resolve, reject) {
    var onAffirmative = function onAffirmative() {
      dispatch(setConfirmationDialog(false, title, text, affirmativeButtonText, negativeButtonText, function () {}, function () {}));
      resolve({
        result: 'affirmative'
      });
    };

    var onNegative = function onNegative() {
      dispatch(setConfirmationDialog(false, title, text, affirmativeButtonText, negativeButtonText, function () {}, function () {}));
      resolve({
        result: 'negative'
      });
    }; // Post Dialog.


    dispatch(setConfirmationDialog(true, title, text, affirmativeButtonText, negativeButtonText, onAffirmative, onNegative));
  });
}

function postGeneralSnackbar(dispatch, state, type, text, selfDismissTime, actionButtonText) {
  return new Promise(function (resolve, reject) {
    var onAction = function onAction() {
      dispatch(setGeneralSnackbar(false, type, message, 0, {
        actionButtonText: actionButtonText,
        onAction: function onAction() {}
      }));
      resolve();
    }; // Post Snackbar.


    dispatch(setGeneralSnackbar(true, type, text, selfDismissTime, {
      actionButtonText: actionButtonText,
      onAction: onAction
    }));

    if (selfDismissTime !== 0) {
      wait(selfDismissTime).then(function () {
        dispatch(setGeneralSnackbar(false, type, text, 0, {
          actionButtonText: actionButtonText,
          onAction: function onAction() {}
        }));
        resolve();
      });
    }
  });
}

function extractTaskList(taskListId, taskLists) {
  return taskLists.find(function (item) {
    return item.uid === taskListId;
  });
}

function wait(ms) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
}

function getProjectName(projects, projectId) {
  if (projects === undefined || projectId === undefined) {
    return '';
  }

  var project = projects.find(function (item) {
    return item.uid === projectId;
  });

  if (project === undefined) {
    return '';
  }

  return project.projectName;
}

function getTaskListName(taskLists, taskListId) {
  if (taskLists === undefined || taskListId === undefined) {
    return '';
  }

  var taskList = taskLists.find(function (item) {
    return item.uid === taskListId;
  });

  if (taskList === undefined) {
    return '';
  }

  return taskList.taskListName;
}

function pushUndoActionAsync(dispatch, getState, getFirestore, getDexie, undoAction) {
  // Maybe Post snackbar. We don't post a snackbar for super common actions so we don't berate the user with snackbars.
  switch (undoAction.type) {
    case "taskDelete":
      postUndoSnackbar(dispatch, getState, getFirestore, getDexie, 6000, "Task deleted");
      break;

    case "taskListDelete":
      postUndoSnackbar(dispatch, getState, getFirestore, getDexie, 6000, "List deleted");
      break;

    case "localProjectDelete":
      postUndoSnackbar(dispatch, getState, getFirestore, getDexie, 10000, "Project deleted");
      break;
  } // Pop the last Undo Action and Commit it.


  var lastUndoAction = getState().lastUndoAction;

  if (lastUndoAction !== null && lastUndoAction !== undefined) {
    commitUndoActionAsync(dispatch, getState, getFirestore, lastUndoAction);
  } // Update State with the new latest Action.


  dispatch(setLastUndoAction(undoAction)); // Update dexie.

  getDexie().lastUndoAction.put(_objectSpread({}, undoAction, {
    id: '0'
  }));
}

function commitUndoActionAsync(_x108, _x109, _x110, _x111) {
  return _commitUndoActionAsync.apply(this, arguments);
}

function _commitUndoActionAsync() {
  _commitUndoActionAsync = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee35(dispatch, getState, getFirestore, undoAction) {
    var ref, _ref116, relatedTaskRefs, projectId, projectRef, projectLayoutRef, taskListRefs, taskRefs;

    return regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            if (!(undoAction.type === 'taskDelete')) {
              _context35.next = 10;
              break;
            }

            ref = getFirestore().doc(undoAction.refPath);
            _context35.prev = 2;
            _context35.next = 5;
            return ref["delete"]();

          case 5:
            _context35.next = 10;
            break;

          case 7:
            _context35.prev = 7;
            _context35.t0 = _context35["catch"](2);
            handleFirebaseUpdateError(_context35.t0, getState(), dispatch);

          case 10:
            // Task List Delete
            if (undoAction.type === 'taskListDelete') {
              _ref116 = getFirestore().doc(undoAction.refPath);
              relatedTaskRefs = undoAction.relatedTaskRefPaths.map(function (refPath) {
                return getFirestore().doc(refPath);
              });
              deleteTaskListAsync(dispatch, getState, getFirestore, undoAction.projectId, _ref116, relatedTaskRefs);
            } // Local Project Delete


            if (undoAction.type === "localProjectDelete") {
              projectId = undoAction.projectId;
              projectRef = getFirestore().doc(undoAction.projectRefPath);
              projectLayoutRef = getFirestore().doc(undoAction.projectLayoutRefPath);
              taskListRefs = undoAction.taskListRefPaths.map(function (refPath) {
                return getFirestore().doc(refPath);
              });
              taskRefs = undoAction.taskRefPaths.map(function (refPath) {
                return getFirestore().doc(refPath);
              });
              deleteLocalProject(dispatch, getFirestore, getState, projectId, projectRef, projectLayoutRef, taskListRefs, taskRefs);
            }

          case 12:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, null, [[2, 7]]);
  }));
  return _commitUndoActionAsync.apply(this, arguments);
}

function deleteTaskListAsync(_x112, _x113, _x114, _x115, _x116, _x117) {
  return _deleteTaskListAsync.apply(this, arguments);
}

function _deleteTaskListAsync() {
  _deleteTaskListAsync = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee36(dispatch, getState, getFirestore, projectId, taskListRef, relatedTaskRefs) {
    var taskListId, batch, projectLayoutRef, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, ref;

    return regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            // Update Firestore.
            taskListId = taskListRef.id; // Build Batch.

            batch = new _firestoreBatchPaginator["default"](getFirestore());

            if (isRemovingLastTaskList(getState, projectId)) {
              // We are about to remove the last Task list. Queue up a request to delete any remaining Project Layouts.
              projectLayoutRef = getProjectLayoutRef(getFirestore, getState, projectId);
              batch.update(projectLayoutRef.doc(projectId), {
                layouts: []
              });
            } // Task list


            batch["delete"](taskListRef); // Tasks.

            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context36.prev = 7;

            for (_iterator4 = relatedTaskRefs[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              ref = _step4.value;
              batch["delete"](ref);
            }

            _context36.next = 15;
            break;

          case 11:
            _context36.prev = 11;
            _context36.t0 = _context36["catch"](7);
            _didIteratorError4 = true;
            _iteratorError4 = _context36.t0;

          case 15:
            _context36.prev = 15;
            _context36.prev = 16;

            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
              _iterator4["return"]();
            }

          case 18:
            _context36.prev = 18;

            if (!_didIteratorError4) {
              _context36.next = 21;
              break;
            }

            throw _iteratorError4;

          case 21:
            return _context36.finish(18);

          case 22:
            return _context36.finish(15);

          case 23:
            _context36.prev = 23;
            _context36.next = 26;
            return batch.commit();

          case 26:
            _context36.next = 31;
            break;

          case 28:
            _context36.prev = 28;
            _context36.t1 = _context36["catch"](23);
            handleFirebaseUpdateError(_context36.t1, getState(), dispatch);

          case 31:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, null, [[7, 11, 15, 23], [16,, 18, 22], [23, 28]]);
  }));
  return _deleteTaskListAsync.apply(this, arguments);
}

function undoAsync(_x118, _x119, _x120, _x121) {
  return _undoAsync.apply(this, arguments);
}

function _undoAsync() {
  _undoAsync = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee37(dispatch, getState, getFirestore, getDexie) {
    var lastUndoAction, batch, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, refPath, projectRef, projectId;

    return regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            lastUndoAction = getState().lastUndoAction;

            if (!(lastUndoAction === null || lastUndoAction === undefined)) {
              _context37.next = 3;
              break;
            }

            return _context37.abrupt("return");

          case 3:
            if (!(lastUndoAction.type === 'taskDelete')) {
              _context37.next = 13;
              break;
            }

            dispatch(setLastUndoAction(null));
            _context37.prev = 5;
            getFirestore().doc(lastUndoAction.refPath).update({
              isDeleted: false
            });
            getDexie().lastUndoAction["delete"]('0');
            _context37.next = 13;
            break;

          case 10:
            _context37.prev = 10;
            _context37.t0 = _context37["catch"](5);
            throw _context37.t0;

          case 13:
            if (!(lastUndoAction.type === "taskListDelete")) {
              _context37.next = 44;
              break;
            }

            batch = getFirestore().batch();
            batch.update(getFirestore().doc(lastUndoAction.refPath), {
              isDeleted: false
            });
            _iteratorNormalCompletion5 = true;
            _didIteratorError5 = false;
            _iteratorError5 = undefined;
            _context37.prev = 19;

            for (_iterator5 = lastUndoAction.relatedTaskRefPaths[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              refPath = _step5.value;
              batch.update(getFirestore().doc(refPath), {
                isDeleted: false
              });
            }

            _context37.next = 27;
            break;

          case 23:
            _context37.prev = 23;
            _context37.t1 = _context37["catch"](19);
            _didIteratorError5 = true;
            _iteratorError5 = _context37.t1;

          case 27:
            _context37.prev = 27;
            _context37.prev = 28;

            if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
              _iterator5["return"]();
            }

          case 30:
            _context37.prev = 30;

            if (!_didIteratorError5) {
              _context37.next = 33;
              break;
            }

            throw _iteratorError5;

          case 33:
            return _context37.finish(30);

          case 34:
            return _context37.finish(27);

          case 35:
            dispatch(setLastUndoAction(null));
            _context37.prev = 36;
            batch.commit();
            getDexie().lastUndoAction["delete"]('0');
            _context37.next = 44;
            break;

          case 41:
            _context37.prev = 41;
            _context37.t2 = _context37["catch"](36);
            throw _context37.t2;

          case 44:
            if (!(lastUndoAction.type === 'localProjectDelete')) {
              _context37.next = 57;
              break;
            }

            projectRef = getFirestore().doc(lastUndoAction.projectRefPath);
            projectId = lastUndoAction.projectId;
            dispatch(setLastUndoAction(null));
            dispatch(selectProject(projectId));
            _context37.prev = 49;
            projectRef.update({
              isDeleted: false
            });
            getDexie().lastUndoAction["delete"]('0');
            _context37.next = 57;
            break;

          case 54:
            _context37.prev = 54;
            _context37.t3 = _context37["catch"](49);
            throw _context37.t3;

          case 57:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37, null, [[5, 10], [19, 23, 27, 35], [28,, 30, 34], [36, 41], [49, 54]]);
  }));
  return _undoAsync.apply(this, arguments);
}

function postUndoSnackbar(_x122, _x123, _x124, _x125) {
  return _postUndoSnackbar.apply(this, arguments);
}

function _postUndoSnackbar() {
  _postUndoSnackbar = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee38(dispatch, getState, getFirestore, getDexie) {
    var timeout,
        text,
        undoFired,
        onUndo,
        _args38 = arguments;
    return regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            timeout = _args38.length > 4 && _args38[4] !== undefined ? _args38[4] : 4000;
            text = _args38.length > 5 ? _args38[5] : undefined;
            undoFired = false;

            onUndo = function onUndo() {
              undoFired = true;
              dispatch(setUndoSnackbar({
                isOpen: false,
                text: text,
                onUndo: function onUndo() {}
              }));
              undoAsync(dispatch, getState, getFirestore, getDexie);
            };

            dispatch(setUndoSnackbar({
              isOpen: true,
              text: text,
              onUndo: onUndo
            }));
            _context38.next = 7;
            return wait(timeout);

          case 7:
            if (undoFired === false) {
              dispatch(setUndoSnackbar({
                isOpen: false,
                text: text,
                onUndo: function onUndo() {}
              }));
            }

          case 8:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _postUndoSnackbar.apply(this, arguments);
}



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-redux/action-creators/index.js
// module id = 69
// module chunks = 0